<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { Head, Link, useForm, usePage } from '@inertiajs/vue3'
import { ref, watch } from 'vue'
import moment from 'moment'
import 'moment/dist/locale/nl';
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'
import { Switch } from '@headlessui/vue';
import axios from 'axios';
import InputNumber from 'primevue/inputnumber';
import FileUpload from 'primevue/fileupload';
import Galleria from 'primevue/galleria';
import Rating from 'primevue/rating';
import Image from 'primevue/image';
import Calendar from 'primevue/calendar';
import { hasPermission } from '../../../Composables/userHelper';

const fee = ref();
const presentOffer = ref();

const props = defineProps({ users: Array, lot: Object, options: Array, conditionCategories: Array, sellers: Array, dealers: Array, categories: Array, interestedDealers: Array });
const page = usePage();
const user = page.props.auth.user;

const lot = ref(props.lot);
const bidAmount = ref(lot.value.bids.length > 0 ? lot.value.bids[0].amount + 50 : 50);
const bidDealer = ref(null);
const totalBid = ref();

const minimumPrice = ref();

const baseUrl = page.props.url;
const shareInput = ref(null);
const conditionsForm = useForm({
  conditions: lot.value.conditions.map(condition => {
    return {
      answer: condition.answer == 1 ? true : false,
      comment: condition.comment,
      condition_category_id: condition.condition_category_id,
      condition_question_id: condition.condition_question_id,
      custom_question: condition.custom_question,
      existing_id: condition.id,
      enabled: condition.enabled == 1 ? true : false
    }
  }),
});

//add all condition categories to conditionsForm
props.conditionCategories.forEach(category => {
  conditionsForm.conditions = conditionsForm.conditions.concat(category.questions.map(condition => {
    //check if condition_question_id already exists
    if (conditionsForm.conditions.find(formCondition => formCondition && formCondition.condition_question_id === condition.id)) return null;
    return {
      answer: false,
      comment: "",
      condition_category_id: condition.condition_category_id,
      condition_question_id: condition.id,
      custom_question: null,
      existing_id: null,
      enabled: true
    }
  }));
});

function getConditionAnswerModel(questionId, custom) {
  if (custom) {
    return conditionsForm.conditions.find(condition => condition !== null && condition.custom_question !== null && condition.existing_id === questionId).answer;
  }
  if(!conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId)) return null;
  return conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId).answer;
}

function getConditionCommentModel(questionId, custom) {
  if (custom) {
    return conditionsForm.conditions.find(condition => condition !== null && condition.custom_question !== null && condition.existing_id === questionId).comment;
  }

  if(!conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId)) return "";

  return conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId).comment;
}

function setConditionCommentModel(questionId, custom, value) {
  if (custom) {
    conditionsForm.conditions.find(condition => condition !== null && condition.custom_question !== null && condition.existing_id === questionId).comment = value.target.value;
  } else {
    conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId).comment = value.target.value;
  }
}

function getConditionQuestionModel(questionId, custom) {
  if (custom) {
    return conditionsForm.conditions.find(condition => condition !== null && condition.custom_question !== null && condition.existing_id === questionId).custom_question;
  }
  return conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId).custom_question;
}

function setConditionQuestionModel(questionId, custom, value) {
  if (custom) {
    conditionsForm.conditions.find(condition => condition !== null && condition.custom_question !== null && condition.existing_id === questionId).custom_question = value.target.value;
  } else {
    conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId).custom_question = value.target.value;
  }
}

function setConditionAnswerModel(questionId, custom) {
  if (custom) {
    conditionsForm.conditions.find(condition => condition !== null && condition.custom_question !== null && condition.existing_id === questionId).answer = !conditionsForm.conditions.find(condition => condition !== null && condition.custom_question !== null && condition.existing_id === questionId).answer;
  } else {
    conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId).answer = !conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId).answer;
  }
}

function getConditionEnabledModel(questionId, custom) {
  if (custom) {
    return conditionsForm.conditions.find(condition => condition !== null && condition.custom_question !== null && condition.existing_id === questionId).enabled;
  }
  // if(!conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId)) return true;

  return conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId).enabled;
}

function setConditionEnabledModel(questionId, custom) {
  if (custom) {
    conditionsForm.conditions.find(condition => condition !== null && condition.custom_question !== null && condition.existing_id === questionId).enabled = !conditionsForm.conditions.find(condition => condition !== null && condition.custom_question !== null && condition.existing_id === questionId).enabled;
  } else {
    conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId).enabled = !conditionsForm.conditions.find(condition => condition !== null && condition.condition_question_id === questionId).enabled;
  }
}

function addQuestionToCategory(categoryId) {
  axios.post('/portal/kavel/'+lot.value.id+'/conditionCategory/'+categoryId+'/question', {
    category_id: categoryId,
  }).then(response => {
    //add question to lot conditions
    lot.value.conditions.push({
        answer: 0,
        comment: "",
        condition_category_id: parseInt(response.data.question.condition_category_id),
        condition_question_id: null,
        custom_question: response.data.question.custom_question,
        id: response.data.question.id,
        enabled: 1
    });

    //add a condition to conditionsForm
    conditionsForm.conditions.push({
      answer: false,
      comment: "",
      condition_category_id: parseInt(response.data.question.condition_category_id),
      condition_question_id: null,
      custom_question: response.data.question.custom_question,
      existing_id: response.data.question.id,
      enabled: 1
    });
  });
}

function copyShareLinkToClipboard() {
  shareInput.value.select();
  document.execCommand('copy');
}
const priceIndication = ref();

function removeFromFavorites(id) {
    axios.get('/portal/kavel/' + id + '/unfavorite')
        .then(response => {
            //loop through all lots and set is_favorite to true if lot id is in response
            lots.value.forEach(lot => {
                if (lot.id === id) {
                    lot.is_favorite = false;
                }
            });
        })
        .catch(error => {
            console.log(error);
        });
}

function addToFavorites(id) {
    axios.get('/portal/kavel/' + id + '/favorite')
        .then(response => {
            //loop through all lots and set is_favorite to true if lot id is in response
            lots.value.forEach(lot => {
                if (lot.id === id) {
                    lot.is_favorite = true;
                }
            });
        })
        .catch(error => {
            console.log(error);
        });
}

function savePriceIndication() {
  if (!priceIndication.value) return;
  axios.post('/portal/kavel/' + lot.value.id + '/price-indication', {
    priceIndication: priceIndication.value,
  }).then(response => {
    lot.value.price_indication = priceIndication.value;

    //set the lot activities to the new activities
    lot.value.activity = response.data.activities;
    showIndication.value = false;
    priceIndication.value = null;
  });
}

function saveMinimumPrice() {
  if (!minimumPrice.value) return;
  axios.post('/portal/kavel/' + lot.value.id + '/minimum-price', {
    minimumPrice: minimumPrice.value,
  }).then(response => {
    lot.value.minimum_price = response.data.minimum_price;
    lot.value.activity = response.data.activities;
    showMinimumPrice.value = false;
    minimumPrice.value = null;
  });
}

const selectedCallStatus = ref("");
const comment = ref(null);

function submitComment() {
  axios.post('/portal/kavel/' + lot.value.id + '/comment', {
    comment: comment.value,
    type: selectedCallStatus.value.length > 0 ? 'call' : 'comment',
    calling_status: selectedCallStatus.value,
  }).then(response => {
    //reset comment value, reset selectedCallStatus value
    comment.value = null;
    selectedCallStatus.value = "";
  }).catch(error => {
    //
  });

}

const callStatuses = [
  { "name": "Voicemail i.v.m. bod", "value": "voicemail" },
  { "name": "Klant denkt na", "value": "thinking" },
  { "name": "Terug bel afspraak", "value": "callback" },
  { "name": "Geen gehoor i.v.m. vragenlijst", "value": "no_pickup" },
]

function translateCallingStatus(callStatus) {
  //look through callStatuses and find the value that matches callStatus, return name of that value
  return callStatuses.find(status => status.value === callStatus).name;
}

const bidError = ref(null);

function placeBid() {
  axios.post('/portal/kavel/' + lot.value.id + '/placeBid', {
    amount: bidAmount.value,
    dealer_id: bidDealer.value,
  }).then(response => {
    if (response.data.error) {
      //show error message
      bidError.value = response.data.error;
    } else {
      showBid.value = false;
      bidError.value = null;
    }
  });
}

const deleteCommentModal = ref(false);
const deletingComment = ref(null);

function openCommentDeleteModal(comment) {
  deleteCommentModal.value = true;
  deletingComment.value = comment;
}

function closeCommentDeleteModal() {
  deleteCommentModal.value = false;
}

function deleteComment(comment) {
  axios.delete('/portal/kavel/' + lot.value.id + '/comment/' + deletingComment.value.id + '/delete').then(response => {
    deleteCommentModal.value = false;

    //delete comment from lot.comments
    lot.value.comments = lot.value.comments.filter(c => c.id !== deletingComment.value.id);
  });
}

function deleteImage(image) {
  axios.delete('/portal/kavel/' + lot.value.id + '/image/' + image.id + '/delete').then(response => {
    //remove image from lot.value.images
    lot.value.images = lot.value.images.filter(img => img.id !== image.id);
  });
}

let formatter = new Intl.NumberFormat('nl-NL', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
});

let eurFormatter = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const tabs = [
  { id: 1, name: 'Alle reacties', href: '#', current: true },
  { id: 2, name: 'Bel Status', href: '#', current: false },
  { id: 3, name: 'Opmerkingen', href: '#', current: false },
]
const selectedTab = ref(1)
const showTask = ref(false)
const showSpecEdit = ref(false)
const showCondEdit = ref(false)
const showCondAdd = ref(false)
const showOptEdit = ref(false)
const showPhotoEdit = ref(false)
const showStatus = ref(false)
const showBid = ref(false)
const showContact = ref(false)
const showShare = ref(false)
const showAutobid = ref(false)
const showIndication = ref(false)
const showFantastisch = ref(false)
const showVoorleggen = ref(false)
const showMinimumPrice = ref(false)
const showDealerInterest = ref(false)
const showBPMCalc = ref(false)
const enabled = ref(false)
const showSetSales = ref(false)

const statusses = ref([
  { name : 'Afwachten op acceptatie', value: "acceptatie" },
  { name : 'Aanpassingen nodig', value: "aanpassingen" },
  { name : 'Geaccepteerd', value: "accepted" },
  { name : 'Gearchiveerd', value: "archived" },
  { name : 'Verkocht', value: "sold" },
  { name : 'Verkoop afgerond', value: "invoiced" },
]);

const statusForm = useForm({
  status: lot.value.status,
  price: null,
  dealer: null
})

const sellerForm = useForm({
  user: lot.value.seller_id
})

const selectedOptions = ref(lot.value.options.map(option => option.id));
function saveOptions() {
  axios.post('/portal/kavel/' + lot.value.id + '/options', {
    options: selectedOptions.value,
  }).then(response => {
    // add all selected options to lot.value.options
    lot.value.options = props.options.filter(option => selectedOptions.value.includes(option.id));
    showOptEdit.value = false;
  });
}

const optionSearch = ref(null);

const filteredOptions = ref(props.options);
function searchOptions() {
  //search props.options for optionSearch.value
  filteredOptions.value = props.options.filter(option => option.name.toLowerCase().includes(optionSearch.value.toLowerCase()));
}

function addOption() {
  if (optionSearch.value === "") return;
  axios.post('/portal/option', {
    option: optionSearch.value,
  }).then(response => {
    var newOption = response.data.option;
    props.options.push(newOption);
    optionSearch.value = "";
    searchOptions();
  });
}

const fileUploader = ref(null);

const imageUploadModalState = ref(false);

function openImageUploadModal() {
  imageUploadModalState.value = true;
}

function closeImageUploadModal() {
  imageUploadModalState.value = false;
}

function uploadImages() {
  fileUploader.value.upload();
}

async function imageUploader(event) {
  const files = event.files;

  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append('images[]', files[i]);
  }

  const imgUpload = await axios.post("/portal/kavel/" + lot.value.id + "/images", formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  if (imgUpload.data) {
    lot.value.images = imgUpload.data.images;
    closeImageUploadModal();
  }

  //add uploaded images to lot.value.images
}

//connect to lot_[lot_id]_bids socket
window.Echo.private('user.' + page.props.auth.user.id)
  .listen('.App\\Events\\NewBidEvent', (e) => {
    //check if bid in event is for this lot
    if (e.bid.lot_id !== lot.value.id) return;
    //push bid to the first index of the bids array
    lot.value.bids.unshift(e.bid);
    //set new minimum bid amount
    bidAmount.value = e.bid.amount + 50;

    //set new highest bid
    lot.value.highest_bid = e.bid.amount;

    getFee(e.bid.amount);
  }).listen('.App\\Events\\NewCommentEvent', (e) => {
    //check if comment in event is for this lot
    if (e.comment.lot_id !== lot.value.id) return;
    //check if lot.value.comments already has this comment
    if (lot.value.comments.find(comment => comment.id === e.commentId)) return;
    //push comment to the first index of the comments array
    lot.value.comments.unshift(e.comment);
    //if comment is a call status, set calling_status of lot to the new call status
    if (e.comment.type === 'call') {
      lot.value.calling_status = e.comment.calling_status;
    }
  }).listen('.App\\Events\\DeletedCommentEvent', (e) => {
    //check if comment in event is for this lot
    if (e.lotId !== lot.value.id) return;
    //remove comment from comments array
    lot.value.comments = lot.value.comments.filter(comment => comment.id !== e.commentId);
  }).listen('.App\\Events\\NewPriceIndicationEvent', (e) => {
    //check if price indication in event is for this lot
    if (e.priceIndication.lot_id !== lot.value.id) return;
    //set new price indication
    lot.value.price_indication = e.priceIndication.priceIndication;
  });

  function getAnswer(questionId) {
    var answer = lot.value.conditions.find(condition => condition.condition_question_id === questionId);

    if (answer) {
      return answer;
    }

    return null;
  }

  function getCustomQuestions(condition_category_id) {
    var conditions = lot.value.conditions.filter(category => category.condition_category_id == condition_category_id && category.custom_question != null);
    return conditions;
  }

  function saveConditions() {
    showCondEdit.value = false;
    showCondAdd.value = false;

    conditionsForm.post('/portal/kavel/' + lot.value.id + '/conditions', {
      preserveScroll: true,
      onSuccess: (response) => {
        lot.value = response.props.lot;

        conditionsForm.conditions = lot.value.conditions.map(condition => {
          return {
            answer: condition.answer == 1 ? true : false,
            comment: condition.comment,
            condition_category_id: condition.condition_category_id,
            condition_question_id: condition.condition_question_id,
            custom_question: condition.custom_question,
            existing_id: condition.id,
            enabled: condition.enabled == 1 ? true : false
          }
        });
      }
    });
  }

  const specificationForm = useForm({
    make: lot.value.make,
    license_plate: lot.value.license_plate,
    model: lot.value.model,
    type: lot.value.type,
    construction_year: lot.value.construction_year,
    mileage: lot.value.mileage,
    fuel_type: lot.value.fuel_type,
    body_type: lot.value.body_type,
    transmission: lot.value.transmission,
    color: lot.value.color,
    upholstery: lot.value.upholstery,
    doors: lot.value.doors,
    seats: lot.value.seats,
    weight: lot.value.weight,
    power: lot.value.power,
    first_admission: lot.value.first_admission,
    NL_issued: lot.value.NL_issued,
    ascription: lot.value.ascription,
    apk_expiry: lot.value.apk_expiry,
    booklets: lot.value.booklets,
    damage_free: lot.value.damage_free,
    driveable: lot.value.driveable,
    VAT_car: lot.value.VAT_car
  });

  function saveSpecs() {
    specificationForm.post('/portal/kavel/' + lot.value.id + '/specifications', {
      preserveScroll: true,
      onSuccess: (response) => {
        showSpecEdit.value = false;
        lot.value = response.props.lot;
      }
    });
  }

  //when bidamount changes, get the fee for the new bid amount
  watch(bidAmount, (newValue) => {
    getFee(newValue);
  });

  const bodyTypes = [
    { "name": "Sedan", "value": "sedan" },
    { "name": "Hatchback", "value": "hatchback" },
    { "name": "Stationwagen", "value": "stationwagen" },
    { "name": "SUV", "value": "suv" },
    { "name": "Coupé", "value": "coupe" },
    { "name": "Cabriolet", "value": "cabriolet" },
    { "name": "MPV (Multi-Purpose Vehicle)", "value": "mpv" },
    { "name": "Pick-up", "value": "pick-up" },
    { "name": "Bestelwagen", "value": "bestelwagen" },
    { "name": "Sportwagen", "value": "sportwagen" },
    { "name": "Roadster", "value": "roadster" },
    { "name": "Limousine", "value": "limousine" },
    { "name": "Crossover", "value": "crossover" },
    { "name": "Overig", "value": "overig" }
]

const constructionYears = [];

for (let i = 0; i < 50; i++) {
    constructionYears.push({ "name": moment().subtract(i, 'years').format('YYYY'), "value": moment().subtract(i, 'years').format('YYYY') });
}

const fuelTypes = [
    { "name": "Benzine", "value": "benzine" },
    { "name": "Diesel", "value": "diesel" },
    { "name": "Elektrisch", "value": "elektriciteit" },
    { "name": "LPG", "value": "lpg" },
    { "name": "Benzine-Elektrisch", "value": "benzine-elektriciteit" },
    { "name": "Diesel-Elektrisch", "value": "diesel-elektriciteit" },
]

const transmissionTypes = [
    { "name": "Handgeschakeld", "value": "handgeschakeld" },
    { "name": "Automaat", "value": "automaat" },
    { "name": "Semi-automaat", "value": "semi-automaat" },
]

const colors = [
    { "name": "Rood", "value": "rood" },
    { "name": "Blauw", "value": "blauw" },
    { "name": "Groen", "value": "groen" },
    { "name": "Zwart", "value": "zwart" },
    { "name": "Wit", "value": "wit" },
    { "name": "Grijs", "value": "grijs" },
    { "name": "Geel", "value": "geel" },
    { "name": "Oranje", "value": "oranje" },
    { "name": "Paars", "value": "paars" },
    { "name": "Roze", "value": "roze" },
    { "name": "Bruin", "value": "bruin" },
    { "name": "Beige", "value": "beige" },
    { "name": "Turquoise", "value": "turquoise" },
    { "name": "Zilver", "value": "zilver" },
    { "name": "Goud", "value": "goud" },
    { "name": "Chroom", "value": "chroom" },
    { "name": "Bronze", "value": "bronze" },
    { "name": "Overig", "value": "overig" },
]

const interiorTypes = [
    { "name": "Stof", "value": "stof" },
    { "name": "Leer", "value": "leer" },
    { "name": "Half leder", "value": "halfleer" },
    { "name": "Alcantara", "value": "alcantara" },
    { "name": "Overig", "value": "overig" },
]

const countdown = ref(true);
var eventTime = moment(lot.value.auction_end_date);

function doCountdown() {
  var duration = moment.duration(eventTime.diff(moment.now()));
  let days = duration.days();
  let hours = duration.hours();
  let minutes = duration.minutes();
  let seconds = duration.seconds();

  if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
    countdown.value = false;
  }
}

doCountdown();

var interval = 1000;
setInterval(function(){
  doCountdown();
}, interval);

function getFee(amount) {
  //do axios call to backend to get the fee for the given amount
  axios.post('/portal/getFee', {amount:amount}).then(response => {
    fee.value = response.data.fee;
    totalBid.value = bidAmount.value;
  });
}

if (lot.value.bids.length > 0) {
  getFee(lot.value.bids[0].amount);
}

function saveStatus() {
  statusForm.post('/portal/kavel/' + lot.value.id + '/status', {
    preserveScroll: true,
    onSuccess: (response) => {
      showStatus.value = false;
      lot.value = response.props.lot;
    }
  });
}

function saveSales() {
  sellerForm.post('/portal/kavel/' + lot.value.id + '/sales', {
    preserveScroll: true,
    onSuccess: (response) => {
      showSetSales.value = false;
      lot.value = response.props.lot;
    }
  });
}

function translateStatus(status) {
  var searchStatus = statusses.value.find(s => s.value === status);

  if (searchStatus) return searchStatus.name;
  return 'Geen status';
}

function presentOfferToCustomer() {
  axios.post('/portal/kavel/' + lot.value.id + '/presentOffer', {
    amount: presentOffer.value,
  }).then(response => {
    showVoorleggen.value = false;
  });
}

function sendFantasticOffer() {{
  axios.post('/portal/kavel/' + lot.value.id + '/fantasticOffer').then(response => {
    showFantastisch.value = false;
  });
}}

const taskForm = useForm({
  name: null,
  due_date: null,
  description: null,
  notify: false,
  notify_at: null,
  lot_id: props.lot.id,
  user_id: user.id,
})

function storeTask() {
  taskForm.post('/portal/taken/aanmaken', {
    preserveScroll: true,
    onSuccess: (response) => {
      taskForm.reset();
      // set taskForm.lot_id
      taskForm.lot_id = props.lot.id;
      showTask.value = false;
      
    },
  })
}

function canSeeImages() {
  //check if user is dealer
  if (user.dealer) {
    //if current lot has status accepted, return true
    if (lot.value.status === 'accepted') return true;
    return false;
  }

  return true;
}

const categories = props.categories.map(category => ({ value: category.id, label: category.name }));

function translateCategory(categoryId) {
  return categories.find(category => category.value === categoryId).label;
}

const showCategory = ref(false);

const categoryForm = useForm({
  category_id: lot.value.category_id,
})

function saveCategory() {
  categoryForm.post('/portal/kavel/' + lot.value.id + '/category', {
    preserveScroll: true,
    onSuccess: (response) => {
      showCategory.value = false;
      lot.value = response.props.lot;
    }
  });
}

const dealerSearchValue = ref('');

const filteredDealers = ref(props.interestedDealers);

function shareWithDealer(dealer) {
  axios.post('/portal/kavel/' + lot.value.id + '/share', {
    dealer_id: dealer.id,
  }).then(response => {
    showShare.value = false;
  });
}

function searchDealers() {
  //search dealers for dealerSearchValue, check full name and company name
  filteredDealers.value = props.interestedDealers.filter(dealer => dealer.full_name.toLowerCase().includes(dealerSearchValue.value.toLowerCase()) || dealer.company_name.toLowerCase().includes(dealerSearchValue.value.toLowerCase()));
}

watch(dealerSearchValue, (newValue) => {
  searchDealers();
});

const deleteBidModal = ref(false);
const bidToDelete = ref(null);

function openBidDeleteModal(bid) {
  deleteBidModal.value = true;
  bidToDelete.value = bid;
}

function closeBidDeleteModal() {
  deleteBidModal.value = false;
}

function deleteBid() {
  axios.post('/portal/kavel/' + lot.value.id + '/bid/' + bidToDelete.value.id + '/remove').then(response => {
    //remove bid from lot.bids
    lot.value.bids = lot.value.bids.filter(bid => bid.id !== bidToDelete.value.id);

    //set new highest bid
    lot.value.highest_bid = lot.value.bids.length > 0 ? lot.value.bids[0].amount : 0;

    //set new minimum bid amount
    bidAmount.value = lot.value.bids.length > 0 ? lot.value.bids[0].amount + 50 : 50;
    closeBidDeleteModal();
  });
}

const showAddress = ref(false);

const addressForm = useForm({
  houseNumber: lot.value.house_number,
  postalCode: lot.value.postal_code,
});

function saveAddress() {
  addressForm.post('/portal/kavel/' + lot.value.id + '/postalCode', {
    preserveScroll: true,
    onSuccess: (response) => {
      showAddress.value = false;
      lot.value = response.props.lot;
    }
  });
}


</script>

<template>
  <Head :title="'Kavel ' + lot.make + ' ' + lot.model + ' ' + lot.construction_year + ' | Mijnautosnelweg'" />
  <main class="relative isolate overflow-hidden lg:overflow-visible px-4 sm:px-6 py-6 space-y-8">
    <div class="flex flex-row justify-between h-5 sm:mt-20 lg:mt-0">
      <nav class="sm:hidden" aria-label="Back">
        <Link href="/portal/aanbod" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 gap-x-1">
          <font-awesome-icon :icon="['fas', 'chevron-left']" class="h-3 w-3 text-gray-400 shrink-0" />
          Terug
        </Link>
      </nav>
      <nav class="hidden sm:flex" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
          <li>
            <div class="flex">
              <Link href="/portal/dashboard" class="text-sm font-medium text-gray-500 hover:text-gray-700">Dashboard
              </Link>
            </div>
          </li>
          <font-awesome-icon :icon="['fas', 'chevron-right']" class="h-3 w-3 text-gray-400 shrink-0" />
          <li>
            <div class="flex items-center">
              <Link href="/portal/aanbod" class="text-sm font-medium text-gray-500 hover:text-gray-700">Aanbod</Link>
            </div>
          </li>
          <font-awesome-icon :icon="['fas', 'chevron-right']" class="h-3 w-3 text-gray-400 shrink-0" />
          <li>
            <div class="flex items-center">
              <Link href="#" class=" text-sm font-medium text-gray-900 hover:text-gray-700">
              Kavel #{{ lot.id }}</Link>
            </div>
          </li>
        </ol>
      </nav>
    </div>
    <div class="grid grid-cols-1 gap-x-8 lg:grid-cols-7 lg:items-start lg:gap-y-10">
      <div class="lg:block lg:sticky lg:col-span-2 lg:top-24 lg:col-start-6  ">
        <div class="text-base leading-7 text-gray-700">
          <div class="">
            <div class="flex justify-between ">
              <h3 class="font-semibold text-gray-900 text-center" v-if="countdown">
                <vue-countdown :time="moment(lot.auction_end_date).diff(moment(), 'seconds') * 1000" v-slot="{ days, hours, minutes, seconds }">
                  Sluit over 
                  <span v-if="days != 0">{{ days }}d </span>
                  <span v-if="hours != 0">{{ hours }}h </span>
                  <span v-if="minutes != 0">{{ minutes }}m </span>
                  <span v-if="seconds != 0">{{ seconds }}s </span>
                </vue-countdown>
              </h3>
              <h3 class="font-semibold text-gray-900 text-center" v-else>Veiling gesloten</h3>
              <div class="flex flex-col gap-2 h-1">
                <button class="">
                  <Link v-if="lot.is_favorite" @click="removeFromFavorites(lot.id)">
                    <font-awesome-icon :icon="['fas', 'heart']" class="h-5 w-5 p-2.5  bg-royalblue-500 hover:bg-royalblue-500/80 text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 rounded-lg shrink-0" />
                  </Link>
                  <Link v-else @click="addToFavorites(lot.id)">
                    <font-awesome-icon :icon="['far', 'heart']" class="h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 rounded-lg shrink-0" />
                  </Link>
                </button>
                <button @click="showShare = true" class="">
                  <font-awesome-icon :icon="['fas', 'share']" class="h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 rounded-lg shrink-0" />
                </button>
              </div>
            </div>
            <div class="" v-if="lot.bids.length > 0">
              <p>Huidig bod</p>
              <p class="font-bold text-6xl">&euro; {{ formatter.format(lot.highest_bid) }}</p>
              <p class="font-thin text-xs">Getoonde prijs is inclusief fees</p>
            </div>
            <div v-else>
              <p class="font-bold text-2xl">Geen biedingen</p>
            </div>
          </div>
          <div :class="lot.bids.length == 0 ? 'mt-12' : 'mt-3'" class="ring-1 rounded-lg p-2 flex flex-row gap-4 mb-8 lg:mb-0" v-if="lot.seller_id">
            <img v-if="lot.seller.avatar" :src="'/storage/avatars/' + lot.seller.avatar" alt="avatar" class="h-12 w-12 rounded-full object-cover">
            <img v-else src="data:image/jpeg;base64,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" alt="" 
            class="rounded-full h-16 w-16">
            <div class="flex flex-col text-gray-900 my-auto">
              <p class="font-base text-sm">Deze kavel word behandeld door:</p>
              <p class="font-semibold">{{ lot.seller.full_name }}</p>
            </div>
          </div>
          <ul role="list" class="hidden lg:block mt-3 h-32 overflow-y-scroll">
            <li v-for="(activity, index) in lot.activity">
              <div class="relative pb-2">
                <span v-if="index !== 4 && index !== lot.activity.length - 1"
                  class="absolute left-5 top-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" />
                <div class="relative flex items-start space-x-3">
                  <template v-if="activity.action === 'offer' && !user.dealer">
                    <div class="relative px-1">
                      <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200">
                        <font-awesome-icon :icon="['fas', 'circle-user']" class="h-5 w-5 text-gray-500 shrink-0" />
                      </div>
                    </div>
                    <div class="min-w-0 flex-1 py-0">
                      <div class="text-sm leading-8 text-gray-500">
                        <span class="mr-0.5">
                          <span class="font-medium text-gray-900">{{ activity.user.full_name }}</span>
                          heeft een bod voorgelegd van {{ eurFormatter.format(activity.price) }}
                          {{ moment(activity.created_at).format('DD-MM-YYYY HH:mm') }}
                        </span>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="activity.action === 'minimumprice' && !user.dealer">
                    <div class="relative px-1">
                      <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200">
                        <font-awesome-icon :icon="['fas', 'money-bill']" class="h-5 w-5 text-gray-500 shrink-0" />
                      </div>
                    </div>
                    <div class="min-w-0 flex-1 py-0">
                      <div class="text-sm leading-8 text-gray-500">
                        <span class="mr-0.5">
                          <span class="font-medium text-gray-900">{{ activity.user.full_name }}</span>
                          heeft een minimum prijs toegevoegd van </span>
                        <span class="font-medium text-gray-900"> {{ eurFormatter.format(activity.price) }}</span>
                        {{ moment(activity.created_at).format('DD-MM-YYYY HH:mm') }}
                      </div>
                    </div>
                  </template>
                  <template v-else-if="activity.action === 'fantastic_offer' && !user.dealer">
                    <div class="relative px-1">
                      <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200">
                        <font-awesome-icon :icon="['fas', 'tag']" class="h-5 w-5 text-gray-900 shrink-0" />
                      </div>
                    </div>
                    <div class="min-w-0 flex-1 py-0">
                      <div class="text-sm leading-8 text-gray-500">
                        <span class="mr-0.5">
                          <span class="font-medium text-gray-900">{{ activity.user.full_name }}</span>
                          heeft een fantastisch bod verzonden </span>
                        {{ moment(activity.created_at).format('DD-MM-YYYY HH:mm') }}
                      </div>
                    </div>
                  </template>
                  <template v-else-if="activity.action === 'askingprice' && !user.dealer">
                    <div class="relative px-1">
                      <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200">
                        <font-awesome-icon :icon="['fas', 'money-bill']" class="h-5 w-5 text-gray-500 shrink-0" />
                      </div>
                    </div>
                    <div class="min-w-0 flex-1 py-0">
                      <div class="text-sm leading-8 text-gray-500">
                        <span class="mr-0.5">
                          <span class="font-medium text-gray-900">{{ activity.user.full_name }}</span>
                          heeft een vraagprijs toegevoegd van </span>
                        <span class="font-medium text-gray-900"> {{ eurFormatter.format(activity.price) }}</span>
                        {{ moment(activity.created_at).format('DD-MM-YYYY HH:mm') }}
                      </div>
                    </div>
                  </template>
                  <template v-else-if="activity.action === 'price_indication'">
                    <div class="relative px-1">
                      <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200">
                        <font-awesome-icon :icon="['fas', 'circle-euro']" class="h-5 w-5 text-gray-500 shrink-0" />
                      </div>
                    </div>
                    <div class="min-w-0 flex-1 py-0">
                      <div class="text-sm leading-8 text-gray-500">
                        <span class="mr-0.5">
                          <span class="font-medium text-gray-900">{{ activity.user.full_name }}</span>
                          heeft een prijsindicatie toegevoegd van </span><span class="font-medium text-gray-900"> {{
                            eurFormatter.format(activity.price) }}</span>
                        {{ moment(activity.created_at).format('DD-MM-YYYY HH:mm') }}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </li>
          </ul>
          <div class="hidden lg:block border-t border-gray-200 space-y-2 my-3">
            <div class="grid grid-cols-2 gap-4 mt-6">
              <button @click="showIndication = true" type="button" v-if="!user.dealer && countdown"
                class="secondary-btn">Prijs indicatie</button>
              <button type="button" @click="showBid = true; getFee(bidAmount)" v-if="countdown"
                class="primary-btn">Bieden</button>
            </div>
            <div class=" hidden lg:block" v-if="lot.highest_bid">
              <div class="relative flex space-x-3">
                <div class="flex flex-row w-full items-center justify-between">
                  <p class="text-nowrap text-sm text-gray-500">Bod ex. Fee</p>
                  <p class="whitespace-nowrap font-medium text-gray-900 text-end">{{ eurFormatter.format(lot.bids[0].amount - fee)}}</p>
                </div>
              </div>
              <div class="relative flex space-x-3">
                <div class="flex flex-row w-full items-center justify-between">
                  <p class="text-nowrap text-sm text-gray-500">Fees</p>
                  <p class="whitespace-nowrap font-medium text-gray-900 text-end">{{eurFormatter.format(fee)}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="hidden lg:block border-t border-gray-200 pt-2" v-if="lot.bids.length > 0">
            <ul role="list" class="h-[122px] overflow-y-scroll">
              <li v-for="bid in lot.bids" :key="bid.id">
                <div class="pb-1">
                  <div class="flex space-x-3">
                    <div class="flex flex-row w-full items-center justify-between gap-0.5">
                      <p class="w-4/12 text-sm text-gray-500 truncate" v-if="user.dealer && !bid.user">Dealer</p>
                      <p class="w-5/12 text-sm text-gray-500 truncate" v-else> {{ bid.user.company_name }}</p>
                      <p class="w-3/12 whitespace-nowrap text-left text-xs text-gray-500 truncate">
                        {{ moment(bid.created_at).fromNow() }}
                      </p>
                      <p class=" w-2/6 whitespace-nowrap font-medium text-gray-900 text-end">
                        {{ eurFormatter.format(bid.amount) }}</p>
                         <button @click="openBidDeleteModal(bid)" v-if="hasPermission('lot-remove_bid')" class="ml-1"><font-awesome-icon class="h-4 w-4 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 rounded-lg shrink-0" :icon="['far', 'trash']" /></button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="hidden lg:block border-t border-gray-200 pt-3 space-y-4" v-if="!user.dealer">
            <div class="flex flex-col gap-2">
              <div class="flex flex-row gap-2">
                <button @click="showFantastisch = true" type="button"
                  class="w-full rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Fantastisch bod</button>
                <button @click="showVoorleggen = true" type="button"
                  class="w-full rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Voorgelegd bod</button>
              </div>
              <button @click="showMinimumPrice = true" type="button" v-if="countdown"
                class="w-full rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Minimumprijs</button>
            </div>
          </div>
        </div>
      </div>
      <div class="lg:col-span-5 lg:col-start-1 lg:row-start-1 lg:w-full lg:gap-x-8">
        <div class="hidden fixed pr-8 lg:pr-0 sm:flex flex-row justify-between lg:sticky top-20 md:top-24 w-full bg-white z-10" v-if="!user.dealer">
          <div class="grid grid-cols-8 gap-4 z-40">
            <span class="sr-only">RDW</span>
            <a type="button" href="https://ovi.rdw.nl/" target="_blank" v-if="lot.license_plate"
              class="rounded-md h-10 aspect-square overflow-hidden text-sm font-semibold text-gray-900 cursor-pointer">
              <img
                src="https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/b1/59/81/b159814b-1756-535d-6cec-bff6be87ab01/AppIcon-0-1x_U007emarketing-0-5-0-85-220.png/256x256bb.jpg"
                alt="" class="rounded-md overflow-hidden">
            </a>
            <span class="sr-only">Finik</span>
            <a type="button" :href="'https://finnik.nl/kenteken/' + lot.license_plate" target="_blank"  v-if="lot.license_plate"
              class="rounded-md h-10 aspect-square overflow-hidden text-sm font-semibold text-gray-900 cursor-pointer">
              <img
                src="https://play-lh.googleusercontent.com/V_LNM6s7UabCfGD40Ip096KjErCBJC7wcjsq_gYp__nTzOSaAwdZezhL5b-Ccunmsw"
                alt="" class="rounded-md overflow-hidden">
            </a>
            <span class="sr-only">Autotelex</span>
            <a type="button" href="https://autoimport.autotelex.nl/merk.aspx" target="_blank"
              class="rounded-md h-10 aspect-square overflow-hidden text-sm font-semibold text-gray-900 cursor-pointer">
              <img
                src="https://play-lh.googleusercontent.com/WIu5qTsgEPUU1j3ZadXkuEGcZVlDjHt1DykJ2oH_NuyYk2qadRqTmueWaPiFcCU4eyr9"
                alt="" class="rounded-md overflow-hidden">
            </a>
            <span class="sr-only">Kentekencheck.nl</span>
            <a type="button" :href="'https://www.kentekencheck.nl/' + lot.make + '/' + lot.license_plate" target="_blank"
              class="rounded-md h-10 ring-1 aspect-square overflow-hidden text-sm font-semibold text-gray-900 cursor-pointer">
              <img
                src="https://is5-ssl.mzstatic.com/image/thumb/Purple124/v4/7b/04/6c/7b046c13-cb98-10f7-43cb-505cdc809535/source/256x256bb.jpg"
                alt="" class="rounded-md overflow-hidden">
            </a>
            <span class="sr-only">Autowereld</span>
            <a type="button" :href="'https://www.autowereld.nl/' + lot.make.replace(' ', '-') + '/?q=' + lot.model.replace(' ', '+')"
              target="_blank"
              class="rounded-md h-10 aspect-square overflow-hidden text-sm font-semibold text-gray-900 cursor-pointer">
              <img src="https://media.cdnandroid.com/item_images/1248856/imagen-autowereld-nl-auto-occasions-0ori.jpg"
                alt="" class="rounded-md overflow-hidden">
            </a>
            <span class="sr-only">Gaspedaal</span>
            <a type="button"
              :href="'https://www.gaspedaal.nl/' + lot.make + '?trefw=' + lot.model + '&srt=df-a'"
              target="_blank"
              class="rounded-md h-10 aspect-square overflow-hidden text-sm font-semibold text-gray-900 cursor-pointer">
              <img
                src="https://cdn-1.webcatalog.io/catalog/gaspedaal-nl/gaspedaal-nl-icon-filled-256.png?v=1714818951984"
                alt="" class=" rounded-md overflow-hidden">
            </a>
            <span class="sr-only">Autoscout24</span>
            <a type="button"
              :href="'https://www.autoscout24.nl/lst/' + lot.make + '?atype=C&cy=NL&desc=0&powertype=kw&search_id=1tryq01n82y&sort=standard&source=detailsearch&ustate=N%2CU&version0=' + lot.model"
              target="_blank"
              class="rounded-md h-10 aspect-square overflow-hidden text-sm font-semibold text-gray-900 cursor-pointer">
              <img src="https://cdn-1.webcatalog.io/catalog/autoscout24/autoscout24-icon-filled-256.png?v=1714818807984"
                alt="">
            </a>
            <span class="sr-only">marktplaats</span>
            <a type="button" :href="'https://www.marktplaats.nl/l/auto-s/#q:' + lot.make + '+' + lot.model"
              target="_blank"
              class="rounded-md h-10 aspect-square overflow-hidden text-sm font-semibold text-gray-900 cursor-pointer bg-[#F0A667]">
              <img src="/public/img/mp_logo.webp" alt="" class="rounded-md overflow-hidden">
            </a>
          </div>
          <button @click="showTask = true" type="button"
            class="z-40 w-auto rounded-md bg-royalblue-500 p-2 text-sm font-semibold text-white shadow-sm hover:bg-royalblue-500/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">
            Taak toevoegen
          </button>
          <div
            class="absolute h-20 md:h-24 -top-6 md:-top-8 -right-0 lg:-right-1 bg-white w-screen z-30 border-b lg:border-none">
          </div>
        </div>
        <div class="fixed pr-8 lg:hidden flex flex-col gap-3 justify-between bottom-0 py-3 w-full bg-white z-10">
          <button type="button" @click="showBid = true; getFee(bidAmount)"  v-if="countdown"
            class="z-40 primary-btn">Bieden</button>

          <div class="flex flex-row lg:flex-col gap-4">
            <button @click="showFantastisch = true" type="button" v-if="!user.dealer"
              class="z-40 w-full rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Fantastisch bod</button>
            <button @click="showVoorleggen = true" type="button" v-if="!user.dealer"
              class="z-40 w-full rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Bod voorleggen</button>
          </div>
          <div class="absolute h-36 -bottom-6 right-0 bg-white w-screen z-30 border-t"></div>
        </div>
        <div class="space-y-8">
          <div :class="!user.dealer ? 'grid-cols-1 md:grid-cols-2' : ''" class="grid gap-8 lg:mt-8">
            <div class="ring-1 p-4 flex flex-col rounded-lg shadow-md justify-between" v-if="!user.dealer">
              <div class="space-y-4 divide-y">
                <p class="font-semibold text-gray-900">Gegevens verkoper</p>
                <div class="flex flex-col gap-4 divide-y">
                  <div class="grid grid-cols-3 gap-4 pt-3">
                    <p>Naam</p>
                    <p class="truncate col-span-2 text-right">{{ lot.owner_name }}</p>
                  </div>
                  <div class="grid grid-cols-3 gap-4 pt-3">
                    <p>E-mail</p>
                    <p class="truncate col-span-2 text-right">{{ lot.email_address }}</p>
                  </div>
                  <div class="grid grid-cols-3 gap-4 pt-3">
                    <p>Telefoon</p>
                    <p class="truncate col-span-2 text-right">{{ lot.phone_number }}</p>
                  </div>
                  <div class="grid grid-cols-3 gap-4 pt-3">
                    <p>Adres</p>
                    <p class="truncate col-span-2 text-right">
                      <Link v-if="lot.owner_latitude" class="text-brightorange hover:text-brightorange/80" :href="'/portal/dealer/map/'+lot.owner_latitude+'/'+lot.owner_longitude">
                        {{lot.owner_street }} {{lot.house_number}}, {{ lot.owner_city }}, {{lot.postal_code}}
                      </Link>
                      <span v-else>Adres onbekend</span>
                    </p>
                  </div>
                  <div class="grid grid-cols-3 gap-4 pt-3">
                    <p>Elders te koop</p>
                    <p class="truncate col-span-2 text-right">{{ lot.sell_else ? 'Ja' : 'Nee' }}</p>
                  </div>
                </div>
                <div class="grid grid-cols-3 gap-4 pt-3">
                  <p>Belstatus</p>
                  <p class="truncate col-span-2 text-right">{{ lot.calling_status ? translateCallingStatus(lot.calling_status) : 'Geen status' }}
                  </p>
                </div>
                <div class="grid grid-cols-3 gap-4 pt-3">
                  <p>Kavel status</p>
                  <p class="truncate col-span-2 text-right">{{ lot.status ? translateStatus(lot.status) : 'Geen status' }}
                  </p>
                </div>
                <div class="grid grid-cols-3 gap-4 pt-3">
                  <p>Vraagprijs</p>
                  <p class="truncate col-span-2 text-right">{{ eurFormatter.format(lot.asking_price) }}
                  </p>
                </div>
                <div class="grid grid-cols-3 gap-4 pt-3">
                  <p>Categorie</p>
                  <p class="truncate col-span-2 text-right">{{ lot.category_id ? translateCategory(lot.category_id) : 'Geen categorie' }}
                  </p>
                </div>
              </div>
              <div class="grid grid-cols-2 gap-4 mt-6">
                <button type="button" @click="showContact = true"
                  class="secondary-btn">Contact</button>
                <button type="button" @click="showSetSales = true"
                  class="primary-btn">Koppelen aan verkoper</button>
                <button @click="showStatus = true" type="button"
                  class="w-full rounded-md bg-white border px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">Kavel status</button>
                <button @click="showCategory = true" type="button"
                  class="w-full rounded-md bg-white border px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">Categorie aanpassen</button>
                <button @click="showAddress = true" type="button"
                  class="w-full rounded-md bg-white border px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">Adres aanpassen</button>
                <Link @click="showCategory = true" :href="'/portal/kavel/' + lot.id + '/restart'"
                  class="w-full rounded-md bg-white border px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 text-center">Veiling herstarten</Link>
              </div>
            </div>
            <div class="space-y-8 order-first lg:order-last">
              <div class="ring-1 p-4 flex flex-col rounded-lg shadow-md justify-between h-full">
                <p class="font-semibold text-gray-900">Voertuig foto's</p>
                <div class="space-y-4 my-auto">
                  <Galleria class="flex justify-center mx-auto my-auto" v-if="lot.images.length > 0 && canSeeImages()"
                    :value="lot.images" \ :numVisible="5" :circular="true" :showItemNavigators="true"
                    :showThumbnails="false" :showItemNavigatorsOnHover="true" :showIndicators="true"
                    :changeItemOnIndicatorHover="true">
                    <template #item="slotProps">
                      <img :src="'/storage/vehicle_images/' + slotProps.item.path"
                        class="object-scale-down h-full w-full rounded-lg">
                    </template>
                    <template #thumbnail="slotProps">
                      <img :src="'/storage/vehicle_images/' + slotProps.item.path" style="display: block;" />
                    </template>
                  </Galleria>
                  <div v-else class="flex justify-center">
                    <div class="flex flex-col text-center my-auto">
                      <font-awesome-icon :icon="['fal', 'image']" class="h-12 w-12 mx-auto text-gray-400 shrink-0" />
                      <h3 class="mt-4 text-sm font-semibold text-gray-900">Geen afbeeldingen gevonden.</h3>
                      <p class="mt-1 text-sm text-gray-500">Er zijn nog geen afbeeldingen toegevoegd aan deze kavel!</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ring-1 p-4 flex flex-col rounded-lg shadow-md justify-between">
            <div class="space-y-4">
              <p class="font-semibold text-gray-900">Voertuig staat</p>
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div class="flex flex-row justify-between items-center pt-3">
                  <p>Staat exterieur</p>
                  <p>
                    <Rating v-model="lot.exterior_state" readonly :cancel="false" />
                  </p>
                </div>
                <div class="flex flex-row justify-between items-center pt-3">
                  <p>Staat interieur</p>
                  <p>
                    <Rating v-model="lot.interior_state" readonly :cancel="false" />
                  </p>
                </div>
                <div class="flex flex-row justify-between items-center pt-3">
                  <p>Staat banden</p>
                  <p>
                    <Rating v-model="lot.tire_state" readonly :cancel="false" />
                  </p>
                </div>
                <div class="flex flex-row justify-between items-center pt-3">
                  <p>Technische staat</p>
                  <p>
                    <Rating v-model="lot.technical_state" readonly :cancel="false" />
                  </p>
                </div>
                <!-- <div class="flex flex-col lg:col-span-2 border-t gap-4 pt-8">
                  <p>Verkoop reden</p>
                  <p class="font-normal text-sm">{{ lot.sell_reason ?? 'Geen reden aangegeven.' }}</p>
                </div> -->
              </div>
            </div>
          </div>
          <div class="ring-1 p-4 rounded-lg shadow-md">
            <div class="space-y-6">
              <div class="justify-between flex flex-row">
                <p class="font-semibold text-gray-900">Voertuig specificaties</p>
                <div class="flex gap-2 items-center">
                  <button v-if="!showSpecEdit && !user.dealer" type="button" @click="showSpecEdit = true"
                    class="secondary-btn">Wijzigen</button>
                  <button v-if="showSpecEdit && !user.dealer" type="button" @click="saveSpecs"
                    class="primary-btn">Opslaan</button>
                </div>
              </div>
              <div class="relative flex flex-col lg:grid lg:grid-flow-col grid-cols-2 grid-rows-12 gap-x-4">
                <span class="sr-only">Showfields</span>
                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>#</p>
                    <p>{{ lot.id }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Kenteken</p>
                    <p>{{ lot.license_plate }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Merk</p>
                    <p>{{ lot.make }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Model</p>
                    <p>{{ lot.model }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Type</p>
                    <p>{{ lot.type ?? 'n.v.t.' }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Bouwjaar</p>
                    <p>{{ lot.construction_year }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Kilometerstand</p>
                    <p>{{ formatter.format(lot.mileage) }} km</p>
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Brandstof</p>
                    <p>{{ lot.fuel_type }}</p>
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Carrosserie</p>
                    <p>{{ lot.body_type }}</p>
                  </div>
                </li>

                
                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Transmissie</p>
                    <p>{{ lot.transmission }}</p>
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Kleur</p>
                    <p>{{ lot.color }}</p>
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Interieur</p>
                    <p>{{ lot.upholstery }}</p>
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Aantal deuren</p>
                    <p>{{ lot.doors ?? 'n.v.t.' }}</p>
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Aantal stoelen</p>
                    <p>{{ lot.seats ?? 'n.v.t.' }}</p>

                  </div>
                </li>
                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Gewicht</p>
                    <p>{{ lot.weight ? lot.weight + ' kg' : 'n.v.t.' }}</p>
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Vermogen</p>
                    <p>{{ lot.power ? lot.power + ' kW / ' + Math.floor(lot.power * 1.362) + ' pk' : 'n.v.t.' }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Eerste toelating</p>
                    <p>{{ lot.first_admission ? moment(lot.first_admission).format('DD-MM-YYYY') : 'n.v.t.' }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Eerste toelating NL</p>
                    <p>{{ lot.NL_issued ? moment(lot.NL_issued).format('DD-MM-YYYY') : 'n.v.t.' }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Tenaamstelling</p>
                    <p>{{ lot.ascription ? moment(lot.ascription).format('DD-MM-YYYY') : 'n.v.t.' }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>APK vervaldatum</p>
                    <p>{{ lot.APK_expiry ? moment(lot.APK_expiry).format('DD-MM-YYYY') : 'n.v.t.' }}</p>
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Onderhoudsboekjes aanwezig</p>
                    <p>{{ lot.booklets ? 'Ja' : 'Nee' }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Schadevrij</p>
                    <p>{{ lot.damage_free ? 'Ja' : 'Nee' }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Auto rijdbaar</p>
                    <p>{{ !lot.damage_free && !lot.driveable ? 'Nee' : 'Ja' }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="!showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Marge</p>
                    <p>{{ lot.VAT_car ? 'Ja' : 'Nee' }}</p>
                  </div>
                </li>

                <span class="sr-only">Edit fields</span>
                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>#</p>
                    <p>{{ lot.id }}</p>
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Kenteken</p>
                    <input type="text" v-model="specificationForm.license_plate" class="input-style" />
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Merk</p>
                    <input type="text" v-model="specificationForm.make" class="input-style" />
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Model</p>
                    <input type="text" v-model="specificationForm.model" class="input-style" />
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Type</p>
                    <input type="text" v-model="specificationForm.type" class="input-style" />
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Bouwjaar</p>
                    <Dropdown v-model="specificationForm.construction_year" :options="constructionYears" optionLabel="name" optionValue="value" class="dropdown-style" />
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Kilometerstand</p>
                    <InputNumber v-model="specificationForm.mileage" class="input-style" suffix=" km" locale="nl-NL" />
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Brandstof</p>
                    <Dropdown v-model="specificationForm.fuel_type" :options="fuelTypes" optionLabel="name" optionValue="value" class="dropdown-style" />
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Carrosserie</p>
                    <Dropdown v-model="specificationForm.body_type" :options="bodyTypes" optionLabel="name" optionValue="value" class="dropdown-style" />
                  </div>
                </li>

                
                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Transmissie</p>
                    <Dropdown v-model="specificationForm.transmission" :options="transmissionTypes" optionLabel="name" optionValue="value" class="dropdown-style" />
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Kleur</p>
                    <Dropdown v-model="specificationForm.color" :options="colors" optionLabel="name" optionValue="value" class="dropdown-style" />
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Interieur</p>
                    <Dropdown v-model="specificationForm.upholstery" :options="interiorTypes" optionLabel="name" optionValue="value" class="dropdown-style" />
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Aantal deuren</p>
                    <InputNumber v-model="specificationForm.doors" class="input-style" locale="nl-NL"  />
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Aantal stoelen</p>
                    <InputNumber v-model="specificationForm.seats" class="input-style" locale="nl-NL"  />

                  </div>
                </li>
                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Gewicht</p>
                    <InputNumber v-model="specificationForm.weight" suffix=" kg" class="input-style" locale="nl-NL" />
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Vermogen</p>
                    <InputNumber v-model="specificationForm.power" suffix=" kw" class="input-style" locale="nl-NL"/>
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Eerste toelating</p>
                    <Calendar dateFormat="dd-mm-yy" v-model="specificationForm.first_admission" class="datepicker-style" />
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Eerste toelating NL</p>
                    <Calendar dateFormat="dd-mm-yy" v-model="specificationForm.NL_issued" class="datepicker-style" />
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Tenaamstelling</p>
                    <Calendar dateFormat="dd-mm-yy" v-model="specificationForm.ascription" class="datepicker-style" />
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>APK vervaldatum</p>
                    <Calendar dateFormat="dd-mm-yy" v-model="specificationForm.apk_expiry" class="datepicker-style" />
                  </div>
                </li>
                
                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Onderhoudsboekjes aanwezig</p>
                    <Switch
                      v-model="specificationForm.booklets"
                      :class="specificationForm.booklets ? 'bg-royalblue-500' : 'bg-gray-200'"
                      class="relative inline-flex h-6 w-11 items-center rounded-full"
                    >
                      <span class="sr-only">Enable notifications</span>
                      <span
                        :class="specificationForm.booklets ? 'translate-x-6' : 'translate-x-1'"
                        class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                      />
                    </Switch>
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Schadevrij</p>
                    <Switch
                      v-model="specificationForm.damage_free"
                      :class="specificationForm.damage_free ? 'bg-royalblue-500' : 'bg-gray-200'"
                      class="relative inline-flex h-6 w-11 items-center rounded-full"
                    >
                      <span class="sr-only">Enable notifications</span>
                      <span
                        :class="specificationForm.damage_free ? 'translate-x-6' : 'translate-x-1'"
                        class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                      />
                    </Switch>
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Auto rijdbaar</p>
                    <Switch
                      v-model="specificationForm.driveable"
                      :class="specificationForm.driveable ? 'bg-royalblue-500' : 'bg-gray-200'"
                      class="relative inline-flex h-6 w-11 items-center rounded-full"
                    >
                      <span class="sr-only">Enable notifications</span>
                      <span
                        :class="specificationForm.driveable ? 'translate-x-6' : 'translate-x-1'"
                        class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                      />
                    </Switch>
                  </div>
                </li>

                <li class="flex flex-col" v-if="showSpecEdit" >
                  <div class="grid grid-cols-2 gap-4 pt-3">
                    <p>Marge</p>
                    <Switch
                      v-model="specificationForm.VAT_car"
                      :class="specificationForm.VAT_car ? 'bg-royalblue-500' : 'bg-gray-200'"
                      class="relative inline-flex h-6 w-11 items-center rounded-full"
                    >
                      <span class="sr-only">Enable notifications</span>
                      <span
                        :class="specificationForm.VAT_car ? 'translate-x-6' : 'translate-x-1'"
                        class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                      />
                    </Switch>
                  </div>
                </li>
              </div>
            </div>
          </div>
          <div class="ring-1 p-4 rounded-lg shadow-md">
            <div class="space-y-6">
              <div class="justify-between flex flex-row">
                <p class="font-semibold text-gray-900">Voertuig opties</p>
                <div class="flex gap-4 items-center">
                  <button v-if="!showOptEdit && !user.dealer" type="button" @click="showOptEdit = true"
                    class="secondary-btn">Wijzigen</button>
                  <button v-if="showOptEdit && !user.dealer" type="button" @click="saveOptions"
                    class="primary-btn">Opslaan</button>
                </div>
              </div>
              <div v-if="!showOptEdit" class="mt-2 mb-4 w-full">
                <div class="flex flex-wrap gap-y-2 gap-x-3 "v-if="lot.options.length > 0">
                  <div v-for="option in lot.options" :key="value">
                    <div class="border p-2 rounded-lg text-gray-900"><span class="font-normal text-sm">{{ option.name
                        }}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="flex mx-auto justify-center">
                  <div class="flex flex-col text-center">
                    <font-awesome-icon :icon="['far', 'bolt-slash']" class="h-12 w-12 mx-auto text-gray-400 shrink-0" />
                    <h3 class="mt-2 text-sm font-semibol text-gray-900">Geen opties.</h3>
                    <p class="mt-1 text-sm text-gray-500">Er zijn geen opties toegevoegd aan deze kavel.</p>
                  </div>
                </div>

                <!-- <div class="flex flex-col lg:col-span-2 gap-4 pt-8">
                  <p>Extra informatie</p>
                  <p class="font-normal text-sm break-words"><pre>{{ lot.options_extra ?? 'Geen extra opties aangegeven.' }}</pre></p>
                </div> -->
              </div>
              <div v-if="showOptEdit" class="mb-4">
                <div class="mb-2 mt-4">
                  <div class="relative z-0 flex flex-1 items-center justify-center">
                    <div class="flex w-full">
                      <label for="search_options" class="sr-only">Zoeken</label>
                      <div class="flex flex-grow">
                        <div class="pointer-events-none absolute top-0 bottom-0 left-0 flex items-center pl-3">
                          <font-awesome-icon :icon="['fas', 'magnifying-glass']" class="h-5 w-5 mx-auto text-gray-400 shrink-0" />
                        </div>
                        <input id="search_options" name="search_options" v-model="optionSearch" @keyup="searchOptions"
                          class="block w-full rounded-md border-0 bg-white py-1.5 !pl-10 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-brightorange sm:text-sm sm:leading-6"
                          placeholder="Zoeken" type="search" />
                      </div>
                      <button class="rounded-lg ml-5 ring-1 p-2.5 bg-royalblue-500 hover:bg-royalblue-500/80"
                        @click="addOption">
                        <font-awesome-icon :icon="['fal', 'plus']" class="h-5 w-5 text-white shrink-0" />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="mt-5 mb-4 w-full flex flex-wrap gap-y-7 gap-x-3">
                  <div v-for="option in filteredOptions" v-if="filteredOptions.length > 0">
                    <Checkbox v-model="selectedOptions" :value="option.id" :inputId="'option_' + option.id"
                      class="hidden" />
                    <label :for="'option_' + option.id"
                      :class="selectedOptions.includes(option.id) ? 'bg-royalblue-500 text-white' : 'bg-transparent'"
                      class="border p-2 rounded-lg hover:bg-royalblue-500/80 text-gray-900 hover:text-white cursor-pointer transition-colors duration-200 ease-in-out">{{
                        option.name }}</label>
                  </div>
                  <div v-else class="flex mx-auto">
                    <div class="flex flex-col text-center">
                      <font-awesome-icon :icon="['fas', 'bolt-slash']" class="h-12 w-12 mx-auto text-gray-400 shrink-0" />
                      <h3 class="mt-4 text-sm font-semibold text-gray-900">Geen opties gevonden.</h3>
                      <p class="mt-1 text-sm text-gray-500">Klik op de knop naast de zoekbalk om de optie toe te
                        voegen!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ring-1 p-4 rounded-lg shadow-md">
            <div class="space-y-6">
              <div class="justify-between flex flex-row">
                <p class="font-semibold text-gray-900">Voertuig conditie</p>
                <div class="flex gap-2 items-center">
                  <button v-if="!showCondEdit && !user.dealer" type="button" @click="showCondEdit = true; showCondAdd = false"
                    class="secondary-btn">Wijzigen</button>
                  <button v-if="showCondEdit && !user.dealer" type="button" @click="saveConditions"
                    class="primary-btn">Opslaan</button>
                </div>
              </div>
              <div v-if="showCondEdit" v-for="category in props.conditionCategories" class="">
                <div class="flex justify-between">
                  <p class="font-semibold text-base text-gray-900 capitalize">{{ category.name }}</p>
                </div>
                <div v-for="question in category.questions" :key="question.question" :set="answer = getAnswer(question.id)" class="grid grid-cols-2 gap-4 pt-3">
                  <div class="flex flex-row gap-2 items-center">
                    <Switch :v-model="getConditionEnabledModel(question.id, false)" @click="setConditionEnabledModel(question.id, false)"
                      class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-default items-center justify-center rounded-full">
                      <span class="sr-only">Use setting</span>
                      <span aria-hidden="true" class="pointer-events-none absolute h-full w-full rounded-md bg-white" />
                      <span aria-hidden="true"
                        :class="[getConditionEnabledModel(question.id, false) == true ? 'bg-royalblue-500' : 'bg-gray-200', 'pointer-events-none absolute  mx-auto h-6 w-12 rounded-full transition-colors duration-200 ease-in-out']" />
                      <span aria-hidden="true"
                        :class="[getConditionEnabledModel(question.id, false) == true ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out']" />
                    </Switch>
                      <p>{{ question.question }}</p>
                  </div>
                  <div class="flex flex-row gap-2 items-center">
                    <Switch :v-model="getConditionAnswerModel(question.id, false)" @click="setConditionAnswerModel(question.id, false)"
                      class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-default items-center justify-center rounded-full">
                      <span class="sr-only">Use setting</span>
                      <span aria-hidden="true" class="pointer-events-none absolute h-full w-full rounded-md bg-white" />
                      <span aria-hidden="true"
                        :class="[getConditionAnswerModel(question.id, false) == true ? 'bg-royalblue-500' : 'bg-gray-200', 'pointer-events-none absolute  mx-auto h-6 w-12 rounded-full transition-colors duration-200 ease-in-out']" />
                      <span aria-hidden="true"
                        :class="[getConditionAnswerModel(question.id, false) == true ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out']" />
                    </Switch>
                    <div class="flex flex-row gap-0 w-full">
                      <input class="input-style" :value="getConditionCommentModel(question.id, false)" @change="event => setConditionCommentModel(question.id, false, event)" />
                    </div>
                  </div>
                </div>

                <span class="sr-only">Custom question</span>
                <div v-for="customQuestion in getCustomQuestions(category.id)" class="grid grid-cols-2 gap-4 pt-3">
                  <input class="input-style" :value="getConditionQuestionModel(customQuestion.id, true)" @change="event => setConditionQuestionModel(customQuestion.id, true, event)" />
                  <div class="flex flex-row gap-2 items-center">
                    <Switch :v-model="getConditionAnswerModel(customQuestion.id, true)" @click="setConditionAnswerModel(customQuestion.id, true)"
                      class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-default items-center justify-center rounded-full">
                      <span class="sr-only">Use setting</span>
                      <span aria-hidden="true" class="pointer-events-none absolute h-full w-full rounded-md bg-white" />
                      <span aria-hidden="true"
                        :class="[getConditionAnswerModel(customQuestion.id, true) == true ? 'bg-royalblue-500' : 'bg-gray-200', 'pointer-events-none absolute  mx-auto h-6 w-12 rounded-full transition-colors duration-200 ease-in-out']" />
                      <span aria-hidden="true"
                        :class="[getConditionAnswerModel(customQuestion.id, true) == true ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out']" />
                    </Switch>
                    <div class="flex flex-row gap-0 w-full">
                      <input class="input-style" :value="getConditionCommentModel(customQuestion.id, true)" @change="event => setConditionCommentModel(customQuestion.id, true, event)" />
                    </div>
                  </div>
                </div>
                <button @click="addQuestionToCategory(category.id)" class="mt-3 py-3 text-sm font-semibold leading-6 text-royalblue-500 hover:text-royalblue-500/80 hover:underline underline-offset-8 text-left">+ Voeg vraag toe</button>
              </div>
              <div v-if="!showCondEdit" v-for="category in props.conditionCategories" :key="category.id"
                class="mb-4">
                <div class="flex justify-between">
                  <p class="font-semibold text-base text-gray-900 capitalize">{{ category.name }}</p>
                </div>
                <div v-for="question in category.questions" :key="question.question" :set="answer = getAnswer(question.id)" class="">
                  <div v-if="getConditionEnabledModel(question.id, false)" class="grid grid-cols-2 gap-4 pt-3">
                    <p>{{ question.question }}</p>
                    <div class="flex flex-row gap-2 items-center">
                      <Switch readonly :v-model="getConditionAnswerModel(question.id, false)"
                        class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-default items-center justify-center rounded-full">
                        <span class="sr-only">Use setting</span>
                        <span aria-hidden="true" class="pointer-events-none absolute h-full w-full rounded-md bg-white" />
                        <span aria-hidden="true"
                          :class="[getConditionAnswerModel(question.id, false) == true ? 'bg-royalblue-500' : 'bg-gray-200', 'pointer-events-none absolute  mx-auto h-6 w-12 rounded-full transition-colors duration-200 ease-in-out']" />
                        <span aria-hidden="true"
                          :class="[getConditionAnswerModel(question.id, false) == true ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out']" />
                      </Switch>
                      <div class="flex flex-row gap-0">
                        <p class="ml-2" v-if="answer !== null">{{ answer.answer == 1 ? 'Ja' : 'Nee' }}</p>
                        <p v-if="answer !== null && answer.comment" class="lowercase">, {{ answer.comment }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <span class="sr-only">Custom question</span>
                <div v-for="customQuestion in getCustomQuestions(category.id)" class="grid grid-cols-2 gap-4 pt-3">
                  <p>{{ customQuestion.custom_question }}</p>
                  <div class="flex flex-row gap-2 items-center">
                    <Switch readonly
                      class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-default items-center justify-center rounded-full">
                      <span class="sr-only">Use setting</span>
                      <span aria-hidden="true" class="pointer-events-none absolute h-full w-full rounded-md bg-white" />
                      <span aria-hidden="true"
                        :class="[customQuestion.answer == 1 ? 'bg-royalblue-500' : 'bg-gray-200', 'pointer-events-none absolute  mx-auto h-6 w-12 rounded-full transition-colors duration-200 ease-in-out']" />
                      <span aria-hidden="true"
                        :class="[customQuestion.answer == 1 ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out']" />
                    </Switch>
                    <div class="flex flex-row gap-0">
                      <p class="ml-2">{{ customQuestion.answer == 1 ? 'Ja' : 'Nee' }}</p>
                      <p v-if="customQuestion.comment" class="lowercase">, {{ customQuestion.comment }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ring-1 p-4 rounded-lg shadow-md" v-if="!user.dealer">
            <div class="space-y-6">
              <div class="justify-between flex flex-row">
                <p class="font-semibold text-gray-900">Opmerkingen</p>
                <button @click="showTask = true" type="button"
                  class="w-auto rounded-md bg-royalblue-500 p-2 text-sm font-semibold text-white shadow-sm hover:bg-royalblue-500/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">
                  Taak toevoegen
                </button>
              </div>
              <div class="flex flex-col gap-x-6">
                <div class="w-full h-full">
                  <div>
                    <div class="sm:hidden">
                      <label for="tabs" class="sr-only">Select a tab</label>
                      <select id="tabs" name="tabs"
                        class="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-royalblue-500 focus:outline-none focus:ring-royalblue-500 sm:text-sm">
                        <option v-for="tab in tabs" :key="tab.name" :selected="selectedTab == tab">{{ tab.name }}
                        </option>
                      </select>
                    </div>
                    <div class="hidden sm:block">
                      <div class="border-b border-gray-200">
                        <nav class="-mb-px flex space-x-8" aria-label="Tabs">
                          <a v-for="tab in tabs" @click="selectedTab = tab.id" :key="tab.name"
                            :class="[selectedTab === tab.id ? 'border-royalblue-500 text-royalblue-500' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium cursor-pointer']"
                            :aria-current="tab.current ? 'page' : undefined">{{ tab.name }}</a>
                        </nav>
                      </div>
                    </div>
                  </div>

                  <div v-if="lot.comments.length > 0">
                    <div v-if="selectedTab === 1" class="py-3 divide-y">
                      <div v-for="comment in lot.comments" :key="comment.id"
                        class="flex flex-row gap-4 items-center py-4">
                        <div class="flex flex-col gap-2 w-full">
                          <div class="flex flex-row justify-between text-sm">
                            <p class="font-semibold capitalize">{{ comment.user.first_name }}</p>
                            <p class="flex">{{ moment(comment.created_at).format('DD-MM-YYYY H:mm') }}</p>

                          </div>
                          <p class="text-balance">{{ comment.comment }}</p>
                          <p class="text-balance flex">
                            <span class="flex-grow">
                              <span v-if="comment.type == 'call'"><strong>Belstatus veranderd naar: </strong>{{
                                translateCallingStatus(comment.calling_status) }}</span>
                            </span>
                            <span class="justify-end">
                              <font-awesome-icon @click="openCommentDeleteModal(comment)" :icon="['fal', 'trash-can']" class="ml-2 h-5 w-5 p-2.5 shadow-sm ring-1 ring-inset ring-gray-300 bg-white hover:bg-gray-50 rounded-lg cursor-pointer shrink-0" />
                            </span>
                          </p>
                        </div>
                        <div class="pt-3 border-px border-b border-gray-600"></div>
                      </div>
                    </div>
                    <div v-else-if="selectedTab === 2" class="py-3 divide-y">
                      <div v-for="(comment, index) in lot.comments.filter((comment) => comment.type == 'call')"
                        v-if="lot.comments.filter((comment) => comment.type == 'call').length > 0" :key="index"
                        class="flex flex-row gap-4 items-center py-4">
                        <div class="flex flex-col gap-2 w-full">
                          <div class="flex flex-row justify-between text-sm">
                            <p class="font-semibold capitalize">{{ comment.user.first_name }}</p>
                            <p>{{ moment(comment.created_at).format('DD-MM-YYYY H:mm') }}</p>
                          </div>
                          <p class="text-balance">{{ comment.comment }}</p>
                          <p class="text-balance" v-if="comment.type == 'call'"><strong>Belstatus veranderd naar:
                            </strong>{{ translateCallingStatus(comment.calling_status) }}</p>
                        </div>
                        <div class="pt-3 border-px border-b border-gray-600"></div>
                      </div>
                      <div v-else>
                        <div class="text-center">
                          <font-awesome-icon :icon="['fal', 'comment-lines']" class="h-12 w-12 text-gray-400 mx-auto shrink-0" />
                          <h3 class="mt-4 text-sm font-semibold text-gray-900">Geen belstatus</h3>
                          <p class="mt-1 text-sm text-gray-500">Schrijf hieronder je eerste opmerking met een belstatus.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="selectedTab === 3" class="py-3 divide-y">
                      <div v-for="(comment, index) in lot.comments.filter((comment) => comment.type == 'comment')"
                        v-if="lot.comments.filter((comment) => comment.type == 'comment').length > 0" :key="index"
                        class="flex flex-row gap-4 items-center py-4">
                        <div class="flex flex-col gap-2 w-full">
                          <div class="flex flex-row justify-between text-sm">
                            <p class="font-semibold capitalize">{{ comment.user.first_name }}</p>
                            <p>{{ moment(comment.created_at).format('DD-MM-YYYY H:mm') }}</p>
                          </div>
                          <p class="text-balance">{{ comment.comment }}</p>
                        </div>
                        <div class="pt-3 border-px border-b border-gray-600"></div>
                      </div>
                      <div v-else>
                        <div class="text-center">
                          <font-awesome-icon :icon="['fal', 'comment-lines']" class="h-12 w-12 text-gray-400 mx-auto shrink-0" />
                          <h3 class="mt-4 text-sm font-semibold text-gray-900">Geen opmerking</h3>
                          <p class="mt-1 text-sm text-gray-500">Schrijf hieronder je eerste opmerking.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="py-3 divide-y" v-else>
                    <div class="text-center">
                      <font-awesome-icon :icon="['fal', 'comment-lines']" class="h-12 w-12 text-gray-400 mx-auto shrink-0" />
                      <h3 class="mt-4 text-sm font-semibold text-gray-900">Geen opmerking</h3>
                      <p class="mt-1 text-sm text-gray-500">Schrijf hieronder je eerste opmerking.</p>
                    </div>
                  </div>
                  <div class="mt-2 flex justify-end space-x-2">
                    <div>
                      <select id="status" name="callstatus" v-model="selectedCallStatus"
                        class="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-royalblue-500 focus:border-royalblue-500 sm:text-sm">
                        <option value="">Pas aan indien belstatus</option>
                        <option value="voicemail">Voicemail i.v.m. bod</option>
                        <option value="thinking">Klant denkt na</option>
                        <option value="callback">Terug bel afspraak</option>
                        <option value="no_pickup">Geen gehoor i.v.m. vragenlijst</option>
                      </select>
                    </div>
                  </div>
                  <label for="comment" class="sr-only">Opmerking</label>
                  <div class="mt-5">
                    <textarea rows="5" name="comment" id="comment" v-model="comment"
                      class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-royalblue-500 sm:text-sm sm:leading-6"
                      placeholder="Plaats hier je opmerking..." />
                  </div>
                  <div class="mt-2 flex justify-end">
                    <button @click="submitComment"
                      class="inline-flex items-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/85 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">Reactie
                      plaatsen</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ring-1 p-4 rounded-lg shadow-md">
            <div class="space-y-6">
              <div class="justify-between flex flex-row">
                <p class="font-semibold text-gray-900">Voertuig foto's</p>
                <div class="flex gap-2 items-center">
                  <button v-if="!showPhotoEdit && !user.dealer" type="button" @click="showPhotoEdit = true"
                    class="secondary-btn">Wijzigen</button>
                  <button v-if="showPhotoEdit && !user.dealer" class="rounded-lg ring-1 p-2 bg-white hover:bg-gray-50"
                    @click="openImageUploadModal">
                    <font-awesome-icon :icon="['far', 'plus']" class="h-5 w-5 text-gray-900 shrink-0" />
                  </button>
                  <button v-if="showPhotoEdit && !user.dealer" type="button" @click="showPhotoEdit = false"
                    class="primary-btn">Opslaan</button>
                </div>
              </div>
              <div class="flex flex-col gap-x-6">
                <div class="grid grid-cols-2 lg:grid-cols-3 gap-4" v-if="lot.images.length > 0 && canSeeImages()">
                  <div v-for="image in lot.images" :key="image.id" class="relative w-full h-72">
                    <Image :src="'/storage/vehicle_images/' + image.path" alt=""
                      class="w-full h-full rounded-xl ring-1 overflow-hidden" preview />
                    <button v-if="showPhotoEdit"
                      class="absolute top-2 right-2 rounded-lg ring-1 p-2 bg-white hover:bg-gray-50"
                      @click="deleteImage(image)">
                      <font-awesome-icon :icon="['fal', 'trash-can']" class="h-5 w-5 shrink-0" />
                    </button>
                  </div>
                </div>
                <div v-else>
                  <div class="flex flex-col text-center">
                    <font-awesome-icon :icon="['fal', 'image']" class="h-12 w-12 mx-auto text-gray-400 shrink-0" />
                    <h3 class="mt-4 text-sm font-semibold text-gray-900">Geen afbeeldingen gevonden.</h3>
                    <p class="mt-1 text-sm text-gray-500" v-if="!user.dealer">Klik hierboven op wijzigen om de + knop te tonen!</p>
                    <p class="mt-1 text-sm text-gray-500" v-else>Er zijn nog geen afbeeldingen toegevoegd aan deze kavel!</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="h-24 lg:hidden"></div>
        </div>
      </div>
    </div>
  </main>
  <TransitionRoot as="template" :show="showBid">
    <Dialog as="div" class="relative z-50" @close="showBid = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showBid = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Controleer je bod
                </DialogTitle>
                <button type="button"
                  class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                  @click="showBid = false">
                            <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                  <span class="sr-only">Close modal</span>
                </button>
              </div>
              <div class="grid grid-cols-2 pb-4">
                <div class="relative flex space-x-3">
                  <div class="flex flex-row gap-2 w-full items-center">
                    <div class="relative">
                      <div class="flex h-8 w-8 items-center justify-center rounded-lg bg-royalblue-500">
                        <font-awesome-icon :icon="['far', 'map-location-dot']" class="h-5 w-5 text-white shrink-0" />
                      </div>
                    </div>
                    <p class="whitespace-nowrap font-medium text-gray-900 text-end">Ophalen in {{ lot.owner_city }}</p>
                  </div>
                </div>
              </div>
              <div class="text-left space-y-2">
                <InputNumber v-model="bidAmount" inputId="currency-netherlands" mode="currency" currency="EUR"
                  locale="nl-NL" class="input-style" />
                  <div class="text-red-500" v-if="bidError">{{bidError}}</div>
                <div class="pb-4 space-y-1">
                  <div class="flex flex-row justify-between">
                    <p class="text-sm text-gray-500">Fees</p>
                    <p class="whitespace-nowrap text-right text-sm text-gray-500">{{eurFormatter.format(fee)}}</p>
                  </div>
                  <div class="flex flex-row justify-between">
                    <p class="text-sm text-gray-500">Bod ex. fee</p>
                    <p class="whitespace-nowrap text-right text-sm text-gray-500">{{eurFormatter.format(totalBid - fee)}}</p>
                  </div>
                  <div class="pt-2 flex flex-row justify-between">
                    <p>Totaal:</p>
                    <p>{{eurFormatter.format(totalBid)}}</p>
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <p class="text-sm text-gray-500">Bij het plaatsen van een bod gaat u automatisch akkoord met de
                  <a target="_blank" href="/algemene-voorwaarden" class="text-royalblue-500 hover:underline">algemene voorwaarden</a> van
                  mijnautosnelweg.
                </p>
                <div class="relative mt-6 flex flex-col gap-2" v-if="!user.dealer">
                  <div class="text-sm leading-6">
                    <label for="comments" class="font-medium text-gray-900">Bieding plaatsen voor dealer?</label>
                  </div>
                  <Dropdown v-model="bidDealer" :options="dealers" showClear filter optionLabel="company_name" optionValue="id"
                    placeholder="Selecteer dealer" class="dropdown-style" />
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                <button type="button" v-if="hasPermission('lot-place_bid') || user.dealer"
                  class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                  @click="placeBid">Bod plaatsen</button>
                <button type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                  @click="showBid = false" ref="cancelButtonRef">Annuleer</button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showAutobid">
    <Dialog as="div" class="relative z-50" @close="showAutobid = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showAutobid = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
              <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Plaats een automatisch bod
                </DialogTitle>
                <button type="button"
                  class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                  @click="showAutobid = false">
                            <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                  <span class="sr-only">Close modal</span>
                </button>
              </div>
              <div class="text-left space-y-2">
                <div class="pb-4 space-y-1">
                  <div class="pt-2 flex flex-row justify-between">
                    <p>Wat is een automatisch bod?</p>
                  </div>
                  <div class="flex flex-row justify-between">
                    <p class="text-left text-sm text-gray-500">Bij een automatisch bod bieden wij
                      voor
                      jou indien je overboden word.
                      Wij bieden het eerstvolgende minimum bod tot het aangegeven maximum bedrag is bereikt.
                    </p>
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-2 pb-4">
                <div class="relative flex space-x-3">
                  <div class="flex flex-row gap-2 w-full items-center">
                    <div class="relative">
                      <div class="flex h-8 w-8 items-center justify-center rounded-lg bg-royalblue-500">
                        <font-awesome-icon :icon="['far', 'map-location-dot']" class="h-5 w-5 text-white shrink-0" />
                      </div>
                    </div>
                    <p class="whitespace-nowrap font-medium text-gray-900 text-end">Ophalen in {{ lot.owner_city }}</p>
                  </div>
                </div>
                <div class="relative flex space-x-3">
                  <div class="flex flex-row gap-2 w-full items-center">
                    <div class="relative">
                      <div class="flex h-8 w-8 items-center justify-center rounded-lg bg-royalblue-500">
                        <font-awesome-icon :icon="['far', 'receipt']" class="h-5 w-5 text-white shrink-0" />
                      </div>
                    </div>
                    <p class="whitespace-nowrap font-medium text-gray-900 text-end">Service kosten: 12%</p>
                  </div>
                </div>
              </div>
              <div class="text-left space-y-2">
                <InputNumber v-model="bidAmount" inputId="currency-netherlands" mode="currency" currency="EUR"
                  locale="nl-NL" class="input-style" />
                <div class="pb-4 space-y-1">
                  <div class="flex flex-row justify-between">
                    <p class="text-sm text-gray-500">Fees</p>
                    <p class="whitespace-nowrap text-right text-sm text-gray-500">{{eurFormatter.format(fee)}}</p>
                  </div>
                  <div class="flex flex-row justify-between">
                    <p class="text-sm text-gray-500">Bod ex. fee</p>
                    <p class="whitespace-nowrap text-right text-sm text-gray-500">{{eurFormatter.format(totalBid - fee)}}</p>
                  </div>
                  <div class="pt-2 flex flex-row justify-between">
                    <p>Totaal:</p>
                    <p>{{eurFormatter.format(totalBid)}}</p>
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <p class="text-sm text-gray-500">Bij het plaatsen van een bod gaat u automatisch akkoord met de
                  <a target="_blank" href="/algemene-voorwaarden" class="text-royalblue-500 hover:underline">algemene voorwaarden</a> van
                  mijnautosnelweg.
                </p>
                <div class="relative mt-6 flex flex-col gap-2" v-if="!user.dealer">
                  <div class="text-sm leading-6">
                    <label for="comments" class="font-medium text-gray-900">Bieding plaatsen voor dealer?</label>
                  </div>
                  <Dropdown v-model="bidDealer" :options="dealers" showClear filter optionLabel="company_name" optionValue="id"
                    placeholder="Selecteer dealer" class="dropdown-style" />
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                <button type="button" v-if="hasPermission('lot-place_bid') || user.dealer"
                  class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                  @click="placeBid">Bod plaatsen</button>
                <button type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                  @click="showBid = false" ref="cancelButtonRef">Annuleer</button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showShare">
    <Dialog as="div" class="relative z-50" @close="showShare = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showShare = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Delen
                </DialogTitle>
                <button type="button"
                  class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                  @click="showShare = false">
                            <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                  <span class="sr-only">Close modal</span>
                </button>
              </div>
              <div class="mt-2" >
                <label v-if="!user.dealer" for="category" class="block text-sm font-medium text-gray-900">Deel dit kavel met dealers of
                  verkopers</label>
                <div class="flex flex-col">
                  <div class="my-4 flex flex-col gap-2" v-if="!user.dealer">
                    <div class="flex flex-row gap-2 items-center">
                      <div class="flex items-center w-full">
                        <div class="w-full">
                          <label for="search_dealers" class="sr-only">Zoeken</label>
                          <div class="relative">
                            <div class="pointer-events-none absolute top-0 bottom-0 left-0 flex items-center pl-3">
                              <font-awesome-icon :icon="['far', 'magnifying-glass']" class="h-5 w-5 text-gray-400 shrink-0" />
                            </div>
                            <input name="search_dealers" id="search_dealers" class="search-style"
                              placeholder="Naam of email" type="search" v-model="dealerSearchValue" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2 max-h-72 overflow-y-scroll divide-y pb-6 border-b" v-if="!user.dealer">
                    <div class="pt-2 flex flex-row items-center justify-between gap-2" v-for="dealer in filteredDealers" v-if="filteredDealers.length > 0">
                      <div class="text-sm leading-6">
                        <label for="comments" class="font-medium text-gray-900">{{dealer.full_name}} | {{dealer.company_name}}</label>
                        <p class="text-left text-sm text-gray-700">Merken: {{ dealer.brands.length > 0 ? dealer.brands.map(brand => brand.name).join(', ') : 'Geen merken'}}</p>
                        <p class="text-left text-sm text-gray-700">Categorieën: {{ dealer.categories.length > 0 ? dealer.categories.map(category => category.name).join(', ') : 'Geen categorieën'}}</p>
                        <p class="text-left text-sm text-gray-700">Afstand tot kavel: {{ (dealer.distanceToLot / 1000).toFixed(2) }}km</p>
                      </div>
                      <div class="flex flex-col gap-1.5">
                        <button type="button" @click="shareWithDealer(dealer)"
                          class="items-center gap-1 inline-flex w-28 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:sm:col-start-1 sm:mt-0"
                          ref=""><font-awesome-icon :icon="['far', 'envelope']" class="h-4 w-4 mr-1"/><p class="w-full text-center">Verstuur</p></button>
                        <a :href="'https://wa.me/' + dealer.whatsapp_number" target="_blank"
                          class="items-center gap-1 inline-flex w-28 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:sm:col-start-1 sm:mt-0"
                          ref=""><font-awesome-icon :icon="['fab', 'whatsapp']" class="h-4 w-4 mr-1"/><p class="w-full text-center">Bericht</p></a>
                        <a :href="'tel:' + dealer.phone_number" target="_blank"
                          class="items-center gap-1 mr-3 inline-flex w-28 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:sm:col-start-1 sm:mt-0"
                          ref=""><font-awesome-icon :icon="['far', 'phone']" class="h-4 w-4 mr-1"/><p class="w-full text-center">Bel</p></a>
                      </div>
                    </div>
                    <div v-else>
                      Geen dealers gevonden
                    </div>
                  </div>
                  <div :class="!user.dealer ? 'my-4' : ''" class="relative flex flex-col gap-4">
                    <label for="category" class="block text-sm font-medium text-gray-900">Handmatig delen</label>
                    <div class="flex gap-2">
                      <div class="relative flex items-center w-full">
                        <div class="w-full">
                          <div class="relative">
                            <input name="" ref="shareInput" readonly class="input-style"
                              :value="baseUrl + '/portal/kavel/' + lot.id" type="search" />
                          </div>
                        </div>
                      </div>
                      <button type="button">
                        <font-awesome-icon @click="copyShareLinkToClipboard" :icon="['fal', 'copy']" class="h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 rounded-lg shrink-0" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showIndication">
    <Dialog as="div" class="relative z-50" @close="showIndication = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showIndication = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex flex-col gap-4 p-4">
                <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Prijsindicatie
                  </DialogTitle>
                  <button type="button"
                    class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    @click="showIndication = false">
                              <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                    <span class="sr-only">Close modal</span>
                  </button>
                </div>
                <form action="#">
                  <div class="mb-4">
                    <label for="category" class="block mb-2 text-sm font-medium text-gray-900">Geef aan wat de geschatte
                      kavelwaarde is</label>
                    <div class="mb-2 mt-4">
                      <div class="relative z-0 flex flex-1 items-center justify-center">
                        <InputNumber v-model="priceIndication" inputId="currency-netherlands" mode="currency"
                          currency="EUR" locale="nl-NL" class="input-style" />

                      </div>
                      <p class="text-sm text-gray-500 mb-2 mt-4">De indicatie prijs word getoond aan alle gebruikers,
                        dealers en verkopers.</p>
                    </div>
                  </div>
                </form>
                <div class="sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                    @click="savePriceIndication">Opslaan</button>
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="showIndication = false" ref="cancelButtonRef">Annuleer</button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showStatus">
    <Dialog as="div" class="relative z-50" @close="showStatus = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showStatus = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex flex-col gap-4 p-4">
                <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Kavel status aanpassen
                  </DialogTitle>
                  <button type="button"
                    class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    @click="showStatus = false">
                              <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                    <span class="sr-only">Close modal</span>
                  </button>
                </div>
                <form action="#">
                  <div class="mb-4">
                    <label for="category" class="block mb-2 text-sm font-medium text-gray-900">Selecteer de nieuwe kavel status</label>
                    <div class="relative z-0 flex flex-1 items-center justify-center mb-2 mt-4">
                      <Dropdown v-model="statusForm.status" optionLabel="name" optionValue="value" class="dropdown-style" :options="statusses" />
                    </div>
                  </div>
                  <div class="mb-4" v-if="statusForm.status =='sold'">
                    <label for="category" class="block mb-2 text-sm font-medium text-gray-900">Kies hier de dealer die deze kavel koopt</label>
                    <div class="relative z-0 flex flex-1 items-center justify-center mb-2 mt-4">
                      <Dropdown v-model="statusForm.dealer" optionLabel="company_name" optionValue="id" class="dropdown-style" :options="dealers" filter />
                    </div>
                    <p class="text-red-500 text-sm" v-if="statusForm.errors.price">Dit is een verplicht veld.</p>
                  </div>
                  <div class="mb-4" v-if="statusForm.status =='sold'">
                    <label for="category" class="block mb-2 text-sm font-medium text-gray-900">Voer hier de overeengekomen verkoopprijs in (inclusief fee)</label>
                    <div class="relative z-0 flex flex-1 items-center justify-center mb-2 mt-4">
                      <InputNumber v-model="statusForm.price" inputId="currency-netherlands" mode="currency" currency="EUR"
                        locale="nl-NL" class="input-style" />
                    </div>
                    <p class="text-red-500 text-sm" v-if="statusForm.errors.price">Dit is een verplicht veld.</p>
                  </div>
                </form>
                <div class="sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                    @click="saveStatus">Opslaan</button>
                  <button type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="showStatus = false" ref="cancelButtonRef">Annuleer</button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showSetSales">
    <Dialog as="div" class="relative z-50" @close="showSetSales = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showSetSales = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex flex-col gap-4 p-4">
                <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Verkoper aanpassen
                  </DialogTitle>
                  <button type="button"
                    class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    @click="showSetSales = false">
                              <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                    <span class="sr-only">Close modal</span>
                  </button>
                </div>
                <form action="#">
                  <div class="mb-4">
                    <label for="category" class="block mb-2 text-sm font-medium text-gray-900">Selecteer de verkoper</label>
                    <div class="relative z-0 flex flex-1 items-center justify-center mb-2 mt-4">
                      <Dropdown v-model="sellerForm.user" optionLabel="full_name" optionValue="id" class="dropdown-style" :options="props.sellers" />
                    </div>
                  </div>
                </form>
                <div class="sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                    @click="saveSales">Opslaan</button>
                  <button type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="showSetSales = false" ref="cancelButtonRef">Annuleer</button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showCategory">
    <Dialog as="div" class="relative z-50" @close="showCategory = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showCategory = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex flex-col gap-4 p-4">
                <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Categorie aanpassen
                  </DialogTitle>
                  <button type="button"
                    class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    @click="showCategory = false">
                              <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                    <span class="sr-only">Close modal</span>
                  </button>
                </div>
                <form action="#">
                  <div class="mb-4">
                    <label for="category" class="block mb-2 text-sm font-medium text-gray-900">Selecteer de categorie</label>
                    <div class="relative z-0 flex flex-1 items-center justify-center mb-2 mt-4">
                      <Dropdown v-model="categoryForm.category_id" optionLabel="label" optionValue="value" class="dropdown-style" :options="categories" />
                    </div>
                  </div>
                </form>
                <div class="sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                    @click="saveCategory">Opslaan</button>
                  <button type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="showCategory = false" ref="cancelButtonRef">Annuleer</button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showAddress">
    <Dialog as="div" class="relative z-50" @close="showAddress = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showAddress = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex flex-col gap-4 p-4">
                <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Adres aanpassen
                  </DialogTitle>
                  <button type="button"
                    class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    @click="showAddress = false">
                              <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                    <span class="sr-only">Close modal</span>
                  </button>
                </div>
                <form action="#">
                  <div class="grid grid-cols-2 gap-4">
                    <div class="mb-4">
                      <label for="category" class="block mb-2 text-sm font-medium text-gray-900">Postcode</label>
                      <div class="relative z-0 flex flex-1 items-center justify-center mb-2 mt-4">
                        <input v-model="addressForm.postalCode" inputId="postal_code" class="input-style" />  
                      </div>
                      <p v-if="addressForm.errors.postalCode" class="text-red-500 text-sm">{{ addressForm.errors.postalCode }}</p>
                    </div>
                    <div class="mb-4">
                      <label for="category" class="block mb-2 text-sm font-medium text-gray-900">Huisnummer</label>
                      <div class="relative z-0 flex flex-1 items-center justify-center mb-2 mt-4">
                        <input v-model="addressForm.houseNumber" inputId="house_number" class="input-style" />  
                      </div>
                      <p v-if="addressForm.errors.houseNumber" class="text-red-500 text-sm">{{ addressForm.errors.houseNumber }}</p>
                    </div>
                  </div>
                </form>
                <div class="sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                    @click="saveAddress">Opslaan</button>
                  <button type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="showAddress = false" ref="cancelButtonRef">Annuleer</button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showFantastisch">
    <Dialog as="div" class="relative z-50" @close="showFantastisch = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showFantastisch = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex flex-col gap-4 p-4">
                <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Fantastisch bod
                  </DialogTitle>
                  <button type="button"
                    class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    @click="showFantastisch = false">
                              <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                    <span class="sr-only">Close modal</span>
                  </button>
                </div>
                    <p class="text-sm text-gray-500 mb-2 mt-4">De eigenaar van dit kavel ontvangt via e-mail een
                      automatisch bericht.</p>
                <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                    @click="sendFantasticOffer">Fantastisch bod versturen</button>
                  <button type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="showFantastisch = false" ref="cancelButtonRef">Annuleer</button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showVoorleggen">
    <Dialog as="div" class="relative z-50" @close="showVoorleggen = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showVoorleggen = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex flex-col gap-4 p-4">
                <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Voorgelegd bod
                  </DialogTitle>
                  <button type="button"
                    class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    @click="showVoorleggen = false">
                              <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                    <span class="sr-only">Close modal</span>
                  </button>
                </div>
                <form action="#">
                  <div class="mb-4">
                    <label for="category" class="block mb-2 text-sm font-medium text-gray-900">Geef hier aan wat het voorgelegde bod aan de klant is.</label>
                    <div class="mb-2 mt-4">
                      <div class="relative z-0 flex flex-1 items-center justify-center">
                        <InputNumber v-model="presentOffer" inputId="currency-netherlands" mode="currency"
                          currency="EUR" locale="nl-NL" class="input-style" />
                      </div>
                    </div>
                  </div>
                </form>
                <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                    @click="presentOfferToCustomer">Bod voorleggen</button>
                  <button type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="showVoorleggen = false" ref="cancelButtonRef">Annuleer</button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showContact">
    <Dialog as="div" class="relative z-50" @close="showContact = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showContact = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Contact
                </DialogTitle>
                <button type="button"
                  class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                  @click="showContact = false">
                            <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                  <span class="sr-only">Close modal</span>
                </button>
              </div>
              <form action="#">
                <div class="mb-4">
                  <label for="category" class="block mb-2 text-sm font-medium text-gray-900">Neem contact op met de
                    eigenaar van dit kavel</label>
                  <div class="flex flex-col gap-2 mb-6">
                    <div class="flex items-center justify-between">
                      <div class="flex gap-2">
                        <p class="text-sm text-gray-500 w-32">Whatsapp:</p>
                        <p class="text-sm text-gray-500">{{ lot.phone_number }}</p>
                      </div>
                      <div class="flex justify-end w-32">
                        <a type="button" :href="'https://wa.me/' + lot.phone_number"
                          class="mt-3 gap-4 inline-flex w-full rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                          ref="">
                          <font-awesome-icon :icon="['fal', 'comment']" class="h-5 w-5 shrink-0" />
                          <p class="text-left">Bericht</p>
                        </a>
                      </div>
                    </div>
                    <div class="flex items-center justify-between">
                      <div class="flex gap-2">
                        <p class="text-sm text-gray-500 w-32">Telefoonnummer:</p>
                        <p class="text-sm text-gray-500">{{ lot.phone_number }}</p>
                      </div>
                      <div class="flex justify-end w-32">
                        <a type="button" :href="'tel:' + lot.phone_number"
                          class="mt-3 gap-4 inline-flex w-full rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                          ref="">
                          <font-awesome-icon :icon="['fal', 'phone']" class="h-5 w-5 shrink-0" />
                          <p class="text-left">Bel</p>
                        </a>
                      </div>
                    </div>
                    <div class="flex items-center justify-between">
                      <div class="flex gap-2">
                        <p class="text-sm text-gray-500 w-32">E-mail:</p>
                        <p class="text-sm text-gray-500">{{ lot.email_address }}</p>
                      </div>
                      <div class="flex justify-end w-32">
                        <a type="button" :href="'mailto:' + lot.email_address"
                          class="mt-3 gap-4 inline-flex w-full rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                          ref="">
                          <font-awesome-icon :icon="['fal', 'envelope']" class="h-5 w-5 shrink-0" />
                          <p class="text-left">Mail</p>
                        </a>
                      </div>
                    </div>
                  </div>
                  <label for="category" class="block pt-4 border-t text-sm font-medium text-gray-900">Bod
                    voorgelegd?</label>
                  <div class="mt-4 flex flex-row justify-between items-center gap-2 mb-6">
                    <p class="text-sm text-gray-500">Voer het bod wat besproken is dan hier door</p>
                    <div>
                      <button @click="showVoorleggen = true" type="button"
                        class="mt-3 gap-4 inline-flex w-auto rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                        ref="">Fantastisch bod
                      </button>
                    </div>
                  </div>
                  <label for="category" class="block pt-4 border-t text-sm font-medium text-gray-900">Geen
                    gehoor?</label>
                  <div class="mt-4 flex flex-row justify-between items-center gap-2">
                    <p class="text-sm text-gray-500">Plan dan een terugbel afspraak voor in je takenlijst</p>
                    <div>
                      <button @click="showTask = true" type="button"
                        class="mt-3 gap-4 inline-flex w-auto rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                        ref="">Taak toevoegen
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="imageUploadModalState">
    <Dialog as="div" class="relative z-40" @close="closeImageUploadModal">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-40 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
              <div class="sm:flex sm:items-start">
                <div class="text-center sm:text-left w-full">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Afbeelding uploaden
                  </DialogTitle>
                  <div class="-mt-6">
                    <FileUpload name="images[]" @uploader="imageUploader" :custom-upload="true"
                      :showUploadButton="false" :showCancelButton="false" :multiple="true" accept="image/*"
                      :url="'/portal/kavel/' + lot.id + '/images'" :maxFileSize="1000000" ref="fileUploader">
                      <template #empty>
                        <p class="text-center">Sleep bestanden hierheen om ze te uploaden.</p>
                      </template>
                    </FileUpload>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button type="button"
                  class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 sm:ml-3 sm:w-auto"
                  @click="uploadImages" as="button">Uploaden</button>
                <button type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  @click="closeImageUploadModal" ref="cancelButtonRef">Annuleren</button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showTask">
    <Dialog as="div" class="relative z-50" @close="showTask = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showTask = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex flex-col gap-4 p-4">
                <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Maak een nieuwe taak aan
                  </DialogTitle>
                  <button type="button"
                    class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    @click="showTask = false">
                              <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                    <span class="sr-only">Close modal</span>
                  </button>
                </div>
                <div class=" w-full flex flex-col gap-y-2">
                    <label for="category" class="block text-sm font-medium text-gray-900">Taak titel</label>
                    <input type="text" class="input-style" v-model="taskForm.name" />
                    <div class="text-red-500" v-if="taskForm.errors.name">{{ taskForm.errors.name }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                    <label for="category" class="block text-sm font-medium text-gray-900">Taak beschrijving</label>
                    <textarea class="textarea-style" v-model="taskForm.description" />
                    <div class="text-red-500" v-if="taskForm.errors.description">{{ taskForm.errors.description }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                  <label for="category" class="block text-sm font-medium text-gray-900">Datum en
                    tijd</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Calendar v-model="taskForm.due_date" showTime dateFormat="dd-mm-yy" class="w-full" />
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.due_date">{{ taskForm.errors.due_date }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                  <label for="category" class="block text-sm font-medium text-gray-900">Gebruiker</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Dropdown v-model="taskForm.user_id" class="dropdown-style" filter :options="props.users" optionValue="id" optionLabel="full_name"/>
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.lot_id">{{ taskForm.errors.lot_id }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                  <label for="category" class="block text-sm font-medium text-gray-900">Stuur notificatie</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Switch v-model="taskForm.notify" as="template" v-slot="{ checked }">
                      <button
                        class="relative inline-flex h-6 w-11 items-center rounded-full"
                        :class="checked ? 'bg-royalblue-500' : 'bg-gray-200'"
                      >
                        <span class="sr-only">Notificaties aan</span>
                        <span
                          :class="checked ? 'translate-x-6' : 'translate-x-1'"
                          class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                        />
                      </button>
                    </Switch>
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.notify">{{ taskForm.errors.notify }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3" v-if="taskForm.notify">
                  <label for="category" class="block text-sm font-medium text-gray-900">Datum en tijd voor notificatie</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Calendar v-model="taskForm.notify_at" showTime dateFormat="dd-mm-yy" class="w-full" />
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.notify_at">{{ taskForm.errors.notify_at }}</div>
                </div>
                <div class="sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                    @click="storeTask">Taak opslaan</button>
                  <button type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="showTask = false" ref="cancelButtonRef">Annuleer</button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="showMinimumPrice">
    <Dialog as="div" class="relative z-50" @close="showMinimumPrice = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showMinimumPrice = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex flex-col gap-4 p-4">
                <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Minimum prijs
                  </DialogTitle>
                  <button type="button"
                    class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    @click="showMinimumPrice = false">
                              <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>

                    <span class="sr-only">Close modal</span>
                  </button>
                </div>
                <form action="#">
                  <div class="mb-4">
                    <label for="category" class="block mb-2 text-sm font-medium text-gray-900">Geef aan wat de minimumprijs voor de klant is.</label>
                    <div class="mb-2 mt-4">
                      <div class="relative z-0 flex flex-1 items-center justify-center">
                        <InputNumber v-model="minimumPrice" inputId="currency-netherlands" mode="currency"
                          currency="EUR" locale="nl-NL" class="input-style" />
                      </div>
                    </div>
                  </div>
                </form>
                <div class="sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                    @click="saveMinimumPrice">Opslaan</button>
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="showMinimumPrice = false" ref="cancelButtonRef">Annuleer</button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="deleteCommentModal">
    <Dialog as="div" class="relative z-40" @close="closeCommentDeleteModal">
      <span class="sr-only">Delete dialog</span>
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-40 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
              <div class="sm:flex sm:items-start">
                <div
                  class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                  <font-awesome-icon :icon="['far', 'triangle-exclamation']" class="h-6 w-6 text-red-500 shrink-0" />
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Comment verwijderen
                  </DialogTitle>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">Je staat op het punt een comment te verwijderen. Weet je dit zeker?
                    </p>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button preserve-scroll type="button" @click="deleteComment"
                  class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                  as="button">Verwijderen</button>
                <button type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  @click="closeCommentDeleteModal" ref="cancelButtonRef">Annuleren</button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>

  
  <TransitionRoot as="template" :show="deleteBidModal">
    <Dialog as="div" class="relative z-40" @close="closeBidDeleteModal">
      <span class="sr-only">Delete dialog</span>
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-40 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
              <div class="sm:flex sm:items-start">
                <div
                  class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                  <font-awesome-icon :icon="['far', 'triangle-exclamation']" class="h-6 w-6 text-red-500 shrink-0" />
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Bod verwijderen
                  </DialogTitle>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">Je staat op het punt een bod te verwijderen. Weet je dit zeker?
                    </p>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button preserve-scroll type="button" @click="deleteBid"
                  class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                  as="button">Verwijderen</button>
                <button type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  @click="closeBidDeleteModal" ref="cancelButtonRef">Annuleren</button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
